export const th = {
  app: {
    api: 'API ระบบหลังบ้าน',
    area: 'ระบบหลังบ้าน',
    brand: 'แพลตฟอร์มแอฟฟิลิเอต',
    build: 'บิลด์',
    description:
      'ฟีเจอร์ที่มีสิทธิ์สูงจะยังไม่พร้อมใช้งานจนกว่าจะอนุมัติผู้ให้บริการข้อมูลประจำตัวและนโยบายการอนุญาตสำหรับระบบจริง',
    environment: 'สภาพแวดล้อม',
    foundation: 'สภาพแวดล้อมพื้นฐาน',
    language: 'ภาษา',
    metadata: 'ข้อมูลการปรับใช้',
    timezone: 'เขตเวลาที่แสดง',
    title: 'ยังไม่ได้กำหนดค่าการเข้าถึงระบบหลังบ้าน',
    version: 'เวอร์ชัน',
  },
  nav: {
    groups: {
      overview: 'ภาพรวม',
      organization: 'องค์กร',
      affiliates: 'แอฟฟิลิเอต',
      commissions: 'ค่าคอมมิชชัน',
      operations: 'การดำเนินงาน',
      governance: 'การกำกับดูแล',
    },
    dashboard: 'แดชบอร์ด',
    partners: 'พาร์ทเนอร์',
    agents: 'เอเจนต์',
    adminUsers: 'ผู้ใช้ระบบหลังบ้าน',
    members: 'สมาชิกและผู้แนะนำ',
    affiliateWallets: 'กระเป๋าเงินแอฟฟิลิเอต',
    withdrawals: 'การถอนเงิน',
    games: 'เกม',
    commissionRules: 'กฎค่าคอมมิชชัน',
    commissionLedger: 'บัญชีค่าคอมมิชชัน',
    transactions: 'ธุรกรรม',
    transactionFailures: 'คิวธุรกรรมล้มเหลว',
    apiOperations: 'การดำเนินงาน API',
    reconciliation: 'การกระทบยอด',
    partnerCredit: 'เครดิตพาร์ทเนอร์',
    reports: 'รายงาน',
    reportExports: 'ส่งออกรายงาน',
    approvals: 'การอนุมัติ',
    audit: 'บันทึกการตรวจสอบ',
    securityEvents: 'เหตุการณ์ความปลอดภัย',
  },
  common: {
    actions: 'การดำเนินการ',
    all: 'ทั้งหมด',
    empty: 'ไม่พบผลลัพธ์',
    loading: 'กำลังโหลด…',
    no: 'ไม่ใช่',
    notAvailable: 'ไม่พร้อมใช้งาน',
    search: 'ค้นหา',
    unknown: 'ไม่ทราบ',
    yes: 'ใช่',
  },
  filterPanel: {
    label: 'ตัวกรอง{{page}}',
    more: 'ตัวกรองเพิ่มเติม',
    fewer: 'แสดงตัวกรองน้อยลง',
    activeCount: 'ใช้งาน {{count}} รายการ',
    secondary: 'ตัวกรองเพิ่มเติม',
  },
  pageState: {
    accessDenied: 'ไม่มีสิทธิ์เข้าถึง',
    back: 'ย้อนกลับ',
    error: 'ไม่สามารถโหลดหน้านี้ได้',
    noRecords: 'ไม่พบข้อมูล',
    requestId: 'รหัสคำขอ: {{id}}',
    retry: 'ลองอีกครั้ง',
    unavailable: 'ฟีเจอร์นี้ยังไม่พร้อมใช้งาน',
  },
  auth: {
    accessDenied: 'ปฏิเสธการเข้าถึง',
    accountMenu: 'เมนูบัญชี',
    authenticated: 'ยืนยันตัวตนแล้ว',
    error: 'ระบบยืนยันตัวตนไม่พร้อมใช้งาน',
    loading: 'กำลังตรวจสอบสิทธิ์…',
    logout: 'ออกจากระบบ',
    mockMode: 'DEV · การยืนยันตัวตนจำลอง',
    profile: 'โปรไฟล์',
    unauthenticated: 'จำเป็นต้องเข้าสู่ระบบ',
  },
  errors: {
    generic: 'เกิดข้อผิดพลาด',
    forbidden: 'คุณไม่มีสิทธิ์ดำเนินการนี้',
    network: 'ไม่สามารถเชื่อมต่อบริการได้',
    notFound: 'ไม่พบข้อมูลที่ร้องขอ',
    retry: 'ลองอีกครั้ง',
    validation: 'ตรวจสอบช่องที่ระบุ',
  },
  status: {
    active: 'ใช้งานอยู่',
    approved: 'อนุมัติแล้ว',
    cancelled: 'ยกเลิกแล้ว',
    completed: 'เสร็จสิ้น',
    disabled: 'ปิดใช้งาน',
    failed: 'ล้มเหลว',
    inactive: 'ไม่ได้ใช้งาน',
    pending: 'รอดำเนินการ',
    rejected: 'ปฏิเสธแล้ว',
    suspended: 'ระงับแล้ว',
  },
  dashboard: {
    title: 'แดชบอร์ด',
    scope: 'ภาพรวมการดำเนินงานแอฟฟิลิเอต',
    subtitle: 'ติดตามประสิทธิภาพแอฟฟิลิเอต สัญญาณทางการเงิน และคิวการดำเนินงาน',
    summary: 'สรุป',
    trends: 'แนวโน้ม',
    topAffiliates: 'แอฟฟิลิเอตอันดับสูงสุด',
    topGames: 'เกมอันดับสูงสุด',
    operationalQueues: 'คิวการดำเนินงาน',
    reportingAsOf: 'สแนปช็อตรายงาน ณ {{date}} · เอเชีย/กรุงเทพฯ',
    stale: 'สแนปช็อตรายงานนี้ล้าสมัย ข้อมูลล่าสุด ณ {{date}}',
    empty: 'ไม่มีกิจกรรมในแดชบอร์ดที่ตรงกับตัวกรองเหล่านี้',
    error: 'ไม่สามารถโหลดแดชบอร์ดได้',
    trendChartLabel: 'แผนภูมิแนวโน้มยอดเล่นจริง',
    trendSummary: 'สรุปข้อมูลแนวโน้ม',
    charts: {
      metric: 'ตัวชี้วัด',
      period: 'ช่วงเวลา',
      playAmount: 'ยอดเล่นจริง',
      transactionCount: 'ธุรกรรม',
      showData: 'แสดงตารางข้อมูล',
      trendTable: 'ยอดเล่นจริงและธุรกรรมตามช่วงเวลา',
      trendLabelPlayAmount: 'แผนภูมิแนวโน้มยอดเล่นจริง',
      trendLabelTransactionCount: 'แผนภูมิแนวโน้มจำนวนธุรกรรม',
      walletLabel: 'สัดส่วนยอดคงเหลือกระเป๋าเงินตามสกุลเงิน',
      walletTable: 'ยอดคงเหลือกระเป๋าเงินตามสกุลเงิน',
      topGamesLabel: 'เกมอันดับสูงสุดตามยอดเล่นจริง',
      topGamesLabelForCurrency: 'เกมอันดับสูงสุดตามยอดเล่นจริง สกุล {{currency}}',
      topGamesTable: 'เกมอันดับสูงสุดตามยอดเล่นจริง',
    },
    filters: {
      title: 'ตัวกรองแดชบอร์ด',
      toExclusive: 'ไม่รวมวันที่สิ้นสุด',
      gameTypeId: 'ID ประเภทเกม',
      gameId: 'ID เกม',
      currency: 'สกุลเงิน',
      transactionStatus: 'สถานะธุรกรรม',
      more: 'ตัวกรองเพิ่มเติม',
      fewer: 'ซ่อนตัวกรองเพิ่มเติม',
      reset: 'ยกเลิกการแก้ไข',
    },
    status: {
      calculated: 'คำนวณแล้ว',
      rejected: 'ปฏิเสธ',
    },
    kpis: {
      totalActualPlay: 'ยอดเล่นจริงทั้งหมด',
      netCommission: 'ค่าคอมมิชชันสุทธิ',
      commissionReversals: 'การย้อนค่าคอมมิชชัน',
      transactions: 'ธุรกรรม',
      calculated: 'ธุรกรรมที่คำนวณแล้ว',
      reversed: 'ย้อนรายการ / ปฏิเสธ',
      failed: 'ธุรกรรมล้มเหลว',
      activeUsers: 'ผู้ใช้ที่ใช้งานอยู่',
      registrations: 'การลงทะเบียน',
    },
    wallet: {
      title: 'ยอดคงเหลือกระเป๋าเงิน',
      available: 'พร้อมใช้',
      reserved: 'สำรองไว้',
      view: 'ดูกระเป๋าเงิน',
    },
    withdrawals: {
      title: 'ข้อยกเว้นการถอนเงิน',
      unknown: 'จำนวนเงินที่ไม่ทราบสถานะ',
      investigate: 'ตรวจสอบการถอนเงิน',
    },
    apiHealth: {
      title: 'สถานะ API',
      unavailable: 'Dashboard API ไม่ได้ให้ข้อมูลนี้',
      operational: 'ทำงานปกติ',
      degraded: 'ประสิทธิภาพลดลง',
      outage: 'หยุดให้บริการ',
      latency: 'เวลาแฝง P95: {{value}} มิลลิวินาที',
      successRate: 'อัตราความสำเร็จ: {{value}}%',
      checkedAt: 'ตรวจสอบเมื่อ {{date}}',
    },
    rankings: {
      game: 'เกม',
      affiliate: 'แอฟฟิลิเอต',
      playAmount: 'ยอดเล่นจริง',
      commission: 'ค่าคอมมิชชัน',
    },
  },
  games: {
    title: 'เกม',
    subtitle: 'ตรวจสอบแค็ตตาล็อกเกม การจับคู่ผู้ให้บริการ และการเปิดใช้สำหรับแอฟฟิลิเอต',
    tabs: {
      label: 'ส่วนต่าง ๆ ของ Game Master',
      gameTypes: 'ประเภทเกม',
      games: 'เกม',
    },
    actions: {
      createGameType: 'สร้างประเภทเกม',
      createGame: 'สร้างเกม',
      editGameType: 'แก้ไขประเภทเกม',
      editGame: 'แก้ไขเกม',
      changeStatus: 'เปลี่ยนสถานะ',
      applyGameTypeFilters: 'ใช้ตัวกรองประเภทเกม',
      applyGameFilters: 'ใช้ตัวกรองเกม',
      searchGameTypes: 'ค้นหาประเภทเกม',
      previousGameTypes: 'ก่อนหน้า',
      nextGameTypes: 'ถัดไป',
    },
    fields: {
      code: 'รหัส',
      name: 'ชื่อที่แสดง',
      gameType: 'ประเภทเกม',
      gameTypeCode: 'รหัสประเภทเกม',
      gameTypeName: 'ชื่อประเภทเกม',
      gameCode: 'รหัสเกม',
      gameName: 'ชื่อเกม',
      status: 'สถานะ',
      effectiveStatus: 'สถานะที่มีผล',
      proposedStatus: 'สถานะที่เสนอ',
      dependencies: 'เงื่อนไขที่ยังไม่พร้อม',
      createdAt: 'สร้างเมื่อ',
      updatedAt: 'อัปเดตเมื่อ',
      reason: 'เหตุผล',
    },
    filters: {
      gameTypeCode: 'ตัวกรองรหัสประเภทเกม',
      gameTypeSearch: 'ค้นหาด้วยรหัสประเภทเกม',
      gameCode: 'ตัวกรองรหัสเกม',
      gameType: 'ตัวกรองประเภทเกม',
      name: 'ตัวกรองชื่อที่แสดง',
      status: 'ตัวกรองสถานะ',
    },
    forms: {
      gameTypeCreate: 'สร้างประเภทเกม',
      gameTypeEdit: 'แก้ไขประเภทเกม',
      gameCreate: 'สร้างเกม',
      gameEdit: 'แก้ไขเกม',
      normalizedCode: 'รหัสมาตรฐานที่จะส่งไปยัง API',
      selectGameType: 'เลือกประเภทเกม',
      gameTypeResults: 'แสดง {{shown}} จาก {{total}} · หน้า {{page}} จาก {{pages}}',
    },
    validation: {
      gameTypeCode: 'ใช้ตัวอักษร ตัวเลข ขีดล่าง หรือขีดกลาง 2–32 ตัว',
      gameCode: 'ใช้ตัวอักษร ตัวเลข ขีดล่าง หรือขีดกลาง 2–64 ตัว',
      gameTypeRequired: 'กรุณาเลือกประเภทเกม',
      nameRequired: 'ต้องระบุชื่อที่แสดง',
      nameMaximum: 'ชื่อที่แสดงต้องไม่เกิน 200 ตัวอักษร',
      reasonRequired: 'ต้องระบุเหตุผล',
      reasonMaximum: 'เหตุผลต้องไม่เกิน 2,000 ตัวอักษร',
    },
    status: {
      title: 'เปลี่ยนสถานะวงจรชีวิต',
      impact: '{{code}}: {{current}} → {{next}}',
      dependencies: 'API จะตรวจสอบเงื่อนไขที่เกี่ยวข้องก่อนเปลี่ยนสถานะ',
      blockers: 'เงื่อนไขที่ยังไม่พร้อม: {{blockers}}',
      closedTerminal: 'CLOSED เป็นสถานะสุดท้ายและไม่สามารถเปิดใหม่ได้',
    },
    tables: {
      gameTypes: 'ตารางประเภทเกม',
      games: 'ตารางเกม',
    },
    detail: {
      overview: 'ภาพรวมแค็ตตาล็อก',
      effectiveValue: 'มีผล: {{status}}',
      noDependencies: 'ไม่มีเงื่อนไขที่ยังไม่พร้อม',
      related: 'การดำเนินการที่เกี่ยวข้อง',
      partnerAvailability: 'การเปิดใช้เกมของพาร์ตเนอร์',
      choosePartnerAvailability: 'เลือกพาร์ตเนอร์เพื่อจัดการการเปิดใช้เกมนี้',
    },
    empty: {
      gameTypes: 'ไม่พบประเภทเกมที่ตรงกับตัวกรอง',
      games: 'ไม่พบเกมที่ตรงกับตัวกรอง',
    },
    errors: {
      loadGameTypes: 'ไม่สามารถโหลดประเภทเกมได้',
      loadGames: 'ไม่สามารถโหลดเกมได้',
      detail: 'ไม่สามารถโหลดข้อมูลแค็ตตาล็อกนี้ได้',
      mutation: 'ไม่สามารถบันทึกข้อมูลแค็ตตาล็อกนี้ได้',
      lifecycle: 'ไม่สามารถเปลี่ยนสถานะวงจรชีวิตได้',
    },
    partner: {
      title: 'การเปิดใช้เกมของพาร์ตเนอร์',
      subtitle: 'พาร์ตเนอร์ {{partnerId}} · การเปิดใช้และวงเงินเล่นสูงสุดเฉพาะพาร์ตเนอร์',
      tableLabel: 'ตารางเกมของพาร์ตเนอร์',
      resultCount: 'กำหนดค่าแล้ว {{count}} เกม',
      empty: 'ยังไม่มีเกมที่กำหนดให้พาร์ตเนอร์นี้',
      actions: {
        backToPartner: 'กลับไปยังพาร์ตเนอร์',
        configure: 'กำหนดค่าเกม',
        edit: 'แก้ไขการเปิดใช้',
        save: 'บันทึกการเปิดใช้',
        changeStatus: 'เปลี่ยนสถานะการเปิดใช้',
        searchGames: 'ค้นหาเกม',
      },
      fields: {
        game: 'เกม',
        gameSearch: 'ค้นหาด้วยรหัสเกม',
        currency: 'สกุลเงินที่ล็อกไว้',
        maximumPlayAmount: 'ยอดเล่นสูงสุด',
        effectiveStatus: 'สถานะที่มีผล',
      },
      dialog: {
        createTitle: 'กำหนดการเปิดใช้เกมของพาร์ตเนอร์',
        editTitle: 'แก้ไขการเปิดใช้เกมของพาร์ตเนอร์',
        statusTitle: 'เปลี่ยนสถานะเกมของพาร์ตเนอร์',
        createDescription:
          'API จะสร้างการกำหนดค่านี้ด้วยสถานะ SUSPENDED และใช้สกุลเงินจากค่าเริ่มต้นของพาร์ตเนอร์ที่ล็อกไว้',
        editDescription: 'ตรวจสอบสกุลเงินที่ล็อกไว้และยอดเล่นสูงสุดปัจจุบันก่อนบันทึก',
        statusDescription:
          'การเปิดใช้งานจะตรวจสอบเกม ประเภทเกม พาร์ตเนอร์ และสกุลเงินเริ่มต้นที่ล็อกไว้อีกครั้ง',
        lockedCurrency: 'สกุลเงินที่ล็อกไว้ปัจจุบัน',
        gameResults: 'แสดง {{shown}} จาก {{total}} เกมที่เปิดใช้งานและตรงกับการค้นหา',
        amountImpact: 'ยอดเล่นสูงสุด: {{current}} → {{next}}',
        statusImpact: 'สถานะการเปิดใช้: {{current}} → {{next}}',
      },
      validation: {
        gameRequired: 'กรุณาเลือกเกม',
        amountRequired: 'ต้องระบุยอดเล่นสูงสุด',
        amountInvalid: 'ระบุยอดบวกที่มีเลขจำนวนเต็มไม่เกิน 14 หลักและทศนิยมไม่เกิน 6 หลัก',
      },
      errors: {
        load: 'ไม่สามารถโหลดการเปิดใช้เกมของพาร์ตเนอร์ได้',
        loadGames: 'ไม่สามารถโหลดเกมที่เปิดใช้งานได้',
        mutation: 'ไม่สามารถบันทึกการเปิดใช้เกมของพาร์ตเนอร์ได้',
        currencyConflict:
          'สกุลเงินเริ่มต้นของพาร์ตเนอร์เปลี่ยนแล้ว กรุณาระงับรายการก่อนรีเฟรชสกุลเงินที่ล็อกไว้',
        conflict: 'การเปลี่ยนแปลงเกมของพาร์ตเนอร์ขัดแย้งกับสถานะหรือเงื่อนไขปัจจุบัน',
        notFound: 'ไม่พบการกำหนดค่าเกมของพาร์ตเนอร์นี้แล้ว',
        unavailable: 'เกมของพาร์ตเนอร์นี้ไม่พร้อมสำหรับการดำเนินการที่ขอ',
        gameNotFound: 'ไม่พบเกมที่เลือกแล้ว',
        partnerNotFound: 'ไม่พบพาร์ตเนอร์ที่เลือกแล้ว',
      },
    },
  },
  commissionRules: {
    title: 'กฎค่าคอมมิชชัน',
    subtitle: 'ตรวจสอบการกำหนดค่าคอมมิชชันแบบมีเวอร์ชันที่แก้ไขย้อนหลังไม่ได้และสถานะวงจรชีวิต',
    empty: 'ไม่พบกฎค่าคอมมิชชันที่ตรงกับตัวกรอง',
    gridLabel: 'ตารางกฎค่าคอมมิชชัน',
    actions: {
      new: 'สร้างเวอร์ชันใหม่',
      preview: 'ดูตัวอย่างการคำนวณ',
      create: 'สร้างกฎ',
      reset: 'รีเซ็ตแบบฟอร์ม',
      publish: 'เผยแพร่กฎ',
      cancel: 'ยกเลิกกฎ',
      back: 'กลับไปยังกฎค่าคอมมิชชัน',
    },
    fields: {
      version: 'เวอร์ชัน',
      versionValue: 'เวอร์ชัน {{version}}',
      scope: 'ขอบเขต',
      partnerId: 'Partner ID',
      gameTypeId: 'Game Type ID',
      gameId: 'Game ID',
      game: 'เกม',
      activationMode: 'รูปแบบการเริ่มใช้',
      agentRatePercent: 'อัตราเอเยนต์ (%)',
      affiliateRatePercent: 'อัตราแอฟฟิลิเอต (%)',
      effectiveFrom: 'เริ่มมีผล',
      effectiveTo: 'สิ้นสุดการมีผล',
      lifecycle: 'วงจรชีวิต',
      phase: 'ระยะ',
      effective: 'กำลังมีผล',
      createdAt: 'สร้างเมื่อ',
      createdBy: 'ผู้สร้าง',
      publishedAt: 'เผยแพร่เมื่อ',
      approvedBy: 'ผู้อนุมัติ',
      cancelledAt: 'ยกเลิกเมื่อ',
      cancelledBy: 'ผู้ยกเลิก',
      cancellationReason: 'เหตุผลการยกเลิก',
      sampleActualPlayAmount: 'ยอดเล่นตัวอย่าง',
      sampleCurrencyCode: 'สกุลเงินตัวอย่าง',
      actualPlayAmount: 'ยอดเล่นจริง',
      agentCommissionUnrounded: 'ค่าคอมมิชชันเอเยนต์ก่อนปัดเศษ',
      affiliateCommissionUnrounded: 'ค่าคอมมิชชันแอฟฟิลิเอตก่อนปัดเศษ',
      agentCommission: 'ค่าคอมมิชชันเอเยนต์',
      affiliateCommission: 'ค่าคอมมิชชันแอฟฟิลิเอต',
      totalCommission: 'ค่าคอมมิชชันรวม',
      reason: 'เหตุผล',
    },
    filters: {
      all: 'ทั้งหมด',
      effectiveFrom: 'ตัวกรองเริ่มมีผล',
      effectiveTo: 'ตัวกรองสิ้นสุดการมีผล',
    },
    wizard: {
      title: 'สร้างเวอร์ชันกฎค่าคอมมิชชัน',
      subtitle: 'ดูค่าที่เซิร์ฟเวอร์ปรับรูปแบบก่อนสร้างฉบับร่างที่แก้ไขย้อนหลังไม่ได้',
      impact:
        'เวอร์ชันใหม่อาจกระทบการคำนวณค่าคอมมิชชันในอนาคต โดย snapshot ของธุรกรรมเดิมจะไม่เปลี่ยนแปลง',
    },
    preview: {
      title: 'ตัวอย่างการคำนวณ',
      serverValues: 'แสดงสตริงทศนิยมตามที่เซิร์ฟเวอร์ส่งกลับ และไม่รวมยอดข้ามสกุลเงิน',
      agentFormula: '{{amount}} × {{rate}}% = ค่าคอมมิชชันเอเยนต์ก่อนปัดเศษ',
      affiliateFormula: '{{amount}} × {{rate}}% = ค่าคอมมิชชันแอฟฟิลิเอตก่อนปัดเศษ',
      impact: 'การกำหนดค่านี้กระทบ {{count}} พาร์ตเนอร์',
      normalization: 'การปรับรูปแบบจาก Preview',
      stale: 'แบบฟอร์มมีการเปลี่ยนแปลง กรุณา Preview ใหม่ก่อนสร้าง',
    },
    configuration: {
      scope: 'ขอบเขตที่ปรับรูปแบบ',
      partnerId: 'Partner ID ที่ปรับรูปแบบ',
      gameId: 'Game ID ที่ปรับรูปแบบ',
      activationMode: 'รูปแบบการเริ่มใช้ที่ปรับแล้ว',
      effectiveFrom: 'เวลาเริ่มที่ปรับแล้ว',
      effectiveTo: 'เวลาสิ้นสุดที่ปรับแล้ว',
      agentRatePercent: 'อัตราเอเยนต์ที่ปรับแล้ว',
      affiliateRatePercent: 'อัตราแอฟฟิลิเอตที่ปรับแล้ว',
    },
    notices: {
      overlap: 'ช่วงเวลาที่มีผลทับซ้อนกับกฎค่าคอมมิชชันอื่นที่ใช้ได้',
      partnerImpact: 'ตรวจสอบจำนวนพาร์ตเนอร์ที่ได้รับผลกระทบก่อนสร้างเวอร์ชันนี้',
      gameUnavailable: 'เกมที่เลือกไม่พร้อมสำหรับกฎค่าคอมมิชชันนี้',
      rateTotalExceeded: 'ไม่อนุญาตอัตราค่าคอมมิชชันรวมนี้',
      warningFallback: 'เซิร์ฟเวอร์แจ้งคำเตือนเกี่ยวกับกฎค่าคอมมิชชัน กรุณาตรวจสอบการกำหนดค่า',
      blockerFallback: 'เซิร์ฟเวอร์ไม่อนุญาตการกำหนดค่านี้ กรุณาตรวจสอบข้อมูลหรือติดต่อผู้ดูแล',
    },
    lifecycle: {
      publishTitle: 'เผยแพร่กฎค่าคอมมิชชัน',
      cancelTitle: 'ยกเลิกกฎค่าคอมมิชชัน',
      publishImpact: '{{id}} จะเปลี่ยนจาก {{current}} เป็น {{next}} และอาจกระทบการคำนวณในอนาคต',
      cancelImpact:
        '{{id}} จะเปลี่ยนจาก {{current}} เป็น {{next}} โดยกฎที่กำลังมีผลหรือหมดอายุแล้วจะยกเลิกไม่ได้',
    },
    detail: {
      immutable: 'เวอร์ชันที่มีอยู่แก้ไขย้อนหลังไม่ได้ จึงไม่มีคำสั่งแก้ไขหรือลบ',
      configuration: 'การกำหนดค่าและวงจรชีวิตของกฎ',
      dependencies: 'เงื่อนไขที่ขัดขวาง',
      noDependencies: 'เซิร์ฟเวอร์ไม่รายงานเงื่อนไขที่ขัดขวาง',
    },
    dependencies: {
      referencedByTransactions: 'ถูกอ้างอิงโดย snapshot ของธุรกรรมในอดีต',
      fallback: 'เงื่อนไขจากเซิร์ฟเวอร์ขัดขวางการเปลี่ยนสถานะนี้',
    },
    validation: {
      required: 'จำเป็นต้องระบุข้อมูลนี้',
      rate: 'ระบุเปอร์เซ็นต์ตั้งแต่ 0 ถึง 100 และทศนิยมไม่เกิน 6 หลัก',
      money: 'ระบุยอดบวกและทศนิยมไม่เกิน 6 หลัก',
      currency: 'ระบุรหัสสกุลเงินตัวพิมพ์ใหญ่ 3 ตัว',
      reasonMaximum: 'เหตุผลต้องไม่เกิน 2,000 ตัวอักษร',
    },
    errors: {
      load: 'ไม่สามารถโหลดกฎค่าคอมมิชชันได้',
      detail: 'ไม่สามารถโหลดกฎค่าคอมมิชชันนี้ได้',
      preview: 'ไม่สามารถดูตัวอย่างกฎค่าคอมมิชชันนี้ได้',
      create: 'ไม่สามารถสร้างกฎค่าคอมมิชชันนี้ได้',
      lifecycle: 'ไม่สามารถเปลี่ยนวงจรชีวิตของกฎค่าคอมมิชชันนี้ได้',
      stalePreview: 'Preview หมดอายุ กรุณา Preview ข้อมูลปัจจุบันอีกครั้ง',
      notFound: 'ไม่พบกฎค่าคอมมิชชันนี้แล้ว',
    },
  },
  wallets: {
    title: 'กระเป๋าเงิน Affiliate',
    subtitle: 'ตรวจสอบยอดคงเหลือ สถานะกระเป๋า และประวัติยอดที่แก้ไขย้อนหลังไม่ได้',
    empty: 'ไม่พบกระเป๋าเงิน Affiliate ที่ตรงกับตัวกรอง',
    results: 'ผลลัพธ์กระเป๋าเงิน',
    reconciliationWarning:
      'กระเป๋าเงินนี้ไม่ตรงกับบัญชีรายการที่แก้ไขย้อนหลังไม่ได้ กรุณาตรวจสอบก่อนทำรายการทางการเงิน',
    actions: {
      suspendWallet: 'ระงับกระเป๋าเงิน',
      reactivateWallet: 'เปิดใช้กระเป๋าเงินอีกครั้ง',
      createAdjustment: 'สร้างรายการปรับปรุง',
    },
    fields: {
      walletId: 'รหัสกระเป๋าเงิน',
      partner: 'พาร์ทเนอร์',
      partnerId: 'รหัสพาร์ทเนอร์',
      agent: 'เอเจนต์',
      agentId: 'รหัสเอเจนต์',
      member: 'สมาชิก',
      memberId: 'รหัสสมาชิก',
      username: 'ชื่อผู้ใช้',
      partnerUserId: 'รหัสผู้ใช้ของพาร์ทเนอร์',
      currency: 'สกุลเงิน',
      status: 'สถานะ',
      available: 'ยอดพร้อมใช้',
      reserved: 'ยอดสำรอง',
      total: 'ยอดรวม',
      lifetimeEarned: 'รายได้สะสม',
      lifetimeReversed: 'ยอดกลับรายการสะสม',
      lifetimeAdjusted: 'ยอดปรับปรุงสะสม',
      lifetimeWithdrawn: 'ยอดถอนสะสม',
      version: 'เวอร์ชัน',
      entries: 'จำนวนรายการบัญชี',
      withdrawals: 'จำนวนการถอน',
      lastEntryAt: 'รายการล่าสุด',
      reconciliation: 'การกระทบยอด',
      entryId: 'รหัสรายการ',
      entryType: 'ประเภทรายการ',
      amount: 'จำนวนเงิน',
      availableBefore: 'ยอดพร้อมใช้ก่อนหน้า',
      availableDelta: 'ยอดพร้อมใช้ที่เปลี่ยน',
      availableAfter: 'ยอดพร้อมใช้หลังรายการ',
      reservedBefore: 'ยอดสำรองก่อนหน้า',
      reservedDelta: 'ยอดสำรองที่เปลี่ยน',
      reservedAfter: 'ยอดสำรองหลังรายการ',
      sources: 'ข้อมูลต้นทางที่เชื่อมโยง',
      transactionId: 'รหัสธุรกรรม',
      withdrawalId: 'รหัสการถอน',
      adjustmentId: 'รหัสการปรับปรุง',
      effectiveAt: 'เวลาที่มีผล',
      createdAt: 'เวลาที่สร้าง',
      updatedAt: 'เวลาที่แก้ไข',
    },
    filters: {
      all: 'ทั้งหมด',
      minimumAvailable: 'ยอดพร้อมใช้ต่ำสุด',
      maximumAvailable: 'ยอดพร้อมใช้สูงสุด',
      minimumReserved: 'ยอดสำรองต่ำสุด',
      maximumReserved: 'ยอดสำรองสูงสุด',
      minimumAmount: 'จำนวนเงินต่ำสุด',
      maximumAmount: 'จำนวนเงินสูงสุด',
      effectiveFrom: 'มีผลตั้งแต่',
      effectiveTo: 'มีผลก่อน',
      sort: 'เรียงตาม',
      apply: 'ใช้ตัวกรอง',
    },
    pagination: { previous: 'ก่อนหน้า', next: 'ถัดไป' },
    detail: {
      tabsLabel: 'ส่วนรายละเอียดกระเป๋าเงิน',
      overview: 'ภาพรวม',
      ledger: 'บัญชีรายการ',
      related: 'ข้อมูลที่เกี่ยวข้อง',
      balances: 'ยอดคงเหลือและยอดสะสม',
      identity: 'ข้อมูลกระเป๋าเงินและการกระทบยอด',
    },
    ledger: {
      empty: 'ไม่พบรายการกระเป๋าเงินที่แก้ไขย้อนหลังไม่ได้ตามตัวกรอง',
      results: 'ผลลัพธ์บัญชีรายการกระเป๋าเงิน',
    },
    chart: {
      title: 'ประวัติยอดพร้อมใช้',
      titleScoped: 'แนวโน้มยอดคงเหลือ — {{shown}} จาก {{total}} รายการ',
      available: 'ยอดพร้อมใช้',
      reserved: 'ยอดกันไว้',
      period: 'เวลาที่มีผล',
      accessibleLabel: 'กราฟประวัติยอดคงเหลือเพื่อการแสดงผลเท่านั้น',
      disclaimer:
        'ใช้เพื่อการแสดงผลเท่านั้น โดยคำนวณจากรายการที่แก้ไขย้อนหลังไม่ได้ซึ่งแสดงอยู่ และไม่ใช้เป็นแหล่งข้อมูลทางบัญชี',
    },
    status: {
      suspendImpact:
        'กระเป๋า {{wallet}} สถานะปัจจุบัน: {{current}} สถานะที่เสนอ: {{proposed}} การระงับกระเป๋านี้จะปิดกั้นการถอนใหม่ แต่ไม่ปิดกั้นการกลับรายการรายได้ที่จำเป็น',
      reactivateImpact:
        'กระเป๋า {{wallet}} สถานะปัจจุบัน: {{current}} สถานะที่เสนอ: {{proposed}} การเปิดใช้กระเป๋านี้อีกครั้งจะอนุญาตคำขอถอนใหม่ โดยรายการบัญชีเดิมยังแก้ไขย้อนหลังไม่ได้',
    },
    adjustment: {
      title: 'สร้างรายการปรับปรุงกระเป๋าเงิน',
      description:
        'ดูตัวอย่างรายการปรับปรุงทางการเงินสำหรับกระเป๋า {{wallet}} โดยยอดจะยังไม่เปลี่ยนจนกว่าจะได้รับอนุมัติและดำเนินการแยกต่างหาก',
      signedAmount: 'จำนวนเงินแบบมีเครื่องหมาย',
      amountHelp: 'ระบุจำนวนที่ไม่ใช่ศูนย์พร้อมเครื่องหมาย และทศนิยมไม่เกิน 6 หลัก',
      reasonCode: 'รหัสเหตุผล',
      evidenceReference: 'ข้อมูลอ้างอิงหลักฐาน',
      reason: 'เหตุผล',
      impact: 'ตัวอย่างจากเซิร์ฟเวอร์และผลกระทบทางการเงิน',
      availableBefore: 'ยอดพร้อมใช้ก่อนหน้า',
      delta: 'ยอดปรับปรุง',
      availableAfter: 'ยอดพร้อมใช้หลังรายการ',
      reservedAndTotalAfter: 'ยอดสำรอง / ยอดรวมหลังรายการ',
      notProvided: 'Preview API ไม่ได้ส่งยอดสำรองและยอดรวมหลังรายการ',
      approvalRequired: 'การส่งรายการจะสร้างคำขออนุมัติสถานะ PENDING และยังไม่ลงรายการปรับปรุง',
      confirmImpact: 'ฉันยืนยันเป้าหมายและผลกระทบทางการเงินที่แสดงข้างต้น',
      preview: 'ดูตัวอย่างรายการปรับปรุง',
      submit: 'ส่งเพื่อขออนุมัติ',
      approvalCreated: 'สร้างคำขออนุมัติสถานะ {{status}} แล้ว',
      viewApproval: 'ดูคำขออนุมัติ',
      errors: {
        preview: 'ไม่สามารถดูตัวอย่างรายการปรับปรุงกระเป๋าเงินนี้ได้',
        submit: 'ไม่สามารถส่งรายการปรับปรุงกระเป๋าเงินนี้ได้',
      },
    },
    links: {
      transaction: 'ธุรกรรม',
      withdrawal: 'การถอน',
      commissionLedger: 'บัญชีค่าคอมมิชชัน',
      walletAdjustment: 'การปรับปรุงกระเป๋าเงิน',
      transactions: 'ธุรกรรมที่เชื่อมโยง',
      withdrawals: 'การถอนที่เชื่อมโยง',
      audit: 'กิจกรรมตรวจสอบกระเป๋าเงิน',
    },
    errors: {
      list: 'ไม่สามารถโหลดกระเป๋าเงิน Affiliate ได้',
      detail: 'ไม่สามารถโหลดกระเป๋าเงิน Affiliate นี้ได้',
      entries: 'ไม่สามารถโหลดรายการกระเป๋าเงินที่แก้ไขย้อนหลังไม่ได้',
    },
  },
  withdrawals: {
    title: 'การถอนเงิน Affiliate',
    subtitle: 'ตรวจสอบสถานะการถอน ยอดสำรอง และหลักฐานเครดิตพาร์ทเนอร์ที่ปกปิดข้อมูลแล้ว',
    empty: 'ไม่พบการถอนเงิน Affiliate ที่ตรงกับตัวกรอง',
    results: 'ผลลัพธ์การถอนเงิน',
    serverOrderNote:
      'ผลลัพธ์คงลำดับจากเซิร์ฟเวอร์ ใช้ตัวกรองสถานะ CREDIT_STATUS_UNKNOWN หรือ MANUAL_REVIEW เพื่อตรวจสอบคิวข้อยกเว้น',
    exceptionAction:
      'เงินยังคงถูกสำรองไว้ โปรดตรวจสอบเหตุการณ์ที่แก้ไขย้อนหลังไม่ได้และหลักฐานการส่งก่อนดำเนินการแก้ไขแบบควบคุม',
    receiptGap:
      'API ปัจจุบันไม่มีฟิลด์ใบเสร็จแยกต่างหาก รหัสเครดิตพาร์ทเนอร์และสถานะการส่ง CREDITED คือหลักฐานเครดิตที่มีอยู่',
    actions: {
      retry: 'ตรวจสอบสถานะซ้ำ',
      resolve: 'แก้ไขการถอนเงิน',
    },
    retry: {
      title: 'ลองดำเนินการส่งการถอนเงินอีกครั้ง',
      description:
        'กำหนดการกู้คืนแบบควบคุมโดยใช้รหัสการโอนเดิมที่เปลี่ยนไม่ได้ ระบบจะไม่สร้างรหัสการโอนทดแทน',
      transferId: 'รหัสการโอนเดิม',
      stateChange: 'สถานะปัจจุบัน: {{status}} · สถานะที่เสนอ: RETRY_PENDING',
      impact:
        'บริการจะตรวจสอบผลของการโอนเดิมก่อนลองเครดิตซ้ำ เบราว์เซอร์จะไม่คำนวณหรือเปลี่ยนยอดกระเป๋าเงิน',
      reason: 'เหตุผล',
      confirm: 'ฉันยืนยันว่าการกู้คืนต้องใช้รหัสการโอนเดิม',
      submit: 'กำหนดการลองใหม่',
      scheduled: 'กำหนดการลองใหม่แล้วโดยมีสถานะ RETRY_PENDING',
      errors: { submit: 'ไม่สามารถกำหนดการลองการถอนเงินนี้ใหม่ได้' },
    },
    resolution: {
      title: 'แก้ไขการถอนเงิน',
      description:
        'ดูตัวอย่างการแก้ไขแบบควบคุมสำหรับ {{withdrawal}} การส่งจะสร้างคำขออนุมัติและไม่ได้ทำให้การเปลี่ยนยอดกระเป๋าเงินเสร็จสิ้น',
      resolution: 'วิธีแก้ไข',
      completeProof: 'COMPLETE ต้องมีหลักฐานว่าเครดิตพาร์ทเนอร์เกิดขึ้นแล้ว',
      releaseProof: 'RELEASE ต้องมีหลักฐานว่าเครดิตพาร์ทเนอร์ไม่ได้เกิดขึ้น',
      partnerCreditId: 'รหัสเครดิตพาร์ทเนอร์',
      failureCode: 'รหัสข้อผิดพลาด',
      evidenceReference: 'ข้อมูลอ้างอิงหลักฐาน',
      reason: 'เหตุผล',
      impact: 'ผลกระทบของการแก้ไข',
      amount: 'ยอดที่สำรองไว้',
      proposedState: 'สถานะหลังอนุมัติและดำเนินการ',
      approvalRequired:
        'การส่งจะสร้างคำขออนุมัติสถานะ PENDING ยอดเงินจะไม่เปลี่ยนจนกว่าจะอนุมัติและดำเนินการ',
      confirmImpact: 'ฉันยืนยันเป้าหมาย หลักฐาน และผลกระทบทางการเงินที่เสนอ',
      preview: 'ดูตัวอย่างการแก้ไข',
      submit: 'ส่งเพื่อขออนุมัติ',
      approvalCreated:
        'สร้างคำขออนุมัติสถานะ {{status}} แล้ว การเปลี่ยนยอดกระเป๋าเงินยังไม่เสร็จสิ้น',
      viewApproval: 'ดูคำขออนุมัติ',
      errors: {
        preview: 'ไม่สามารถดูตัวอย่างการแก้ไขการถอนเงินนี้ได้',
        submit: 'ไม่สามารถส่งการแก้ไขการถอนเงินนี้ได้',
      },
    },
    fields: {
      partnerWithdrawalId: 'รหัสถอนเงินของพาร์ทเนอร์',
      internalId: 'รหัสภายใน',
      transferId: 'รหัสการโอน',
      partnerCreditId: 'รหัสเครดิตพาร์ทเนอร์ที่ปกปิด',
      user: 'ผู้ใช้',
      partnerUserId: 'รหัสผู้ใช้พาร์ทเนอร์',
      partner: 'พาร์ทเนอร์',
      partnerId: 'รหัสพาร์ทเนอร์',
      agent: 'เอเจนต์',
      agentId: 'รหัสเอเจนต์',
      walletId: 'รหัสกระเป๋าเงิน',
      memberId: 'รหัสสมาชิก',
      currency: 'สกุลเงิน',
      amount: 'จำนวนเงิน',
      status: 'สถานะ',
      exception: 'ข้อยกเว้น',
      reservedAge: 'อายุยอดสำรอง',
      attempts: 'จำนวนครั้ง',
      lastResponse: 'การตอบกลับล่าสุดจากพาร์ทเนอร์ที่ปกปิด',
      deliveryResult: 'ผลการส่ง',
      failureCode: 'รหัสข้อผิดพลาด',
      failureDetail: 'รายละเอียดข้อผิดพลาดที่ปกปิด',
      minimumAmount: 'จำนวนต่ำสุด',
      maximumAmount: 'จำนวนสูงสุด',
      createdFrom: 'สร้างตั้งแต่',
      createdTo: 'สร้างก่อน',
      completedFrom: 'เสร็จสิ้นตั้งแต่',
      completedTo: 'เสร็จสิ้นก่อน',
      createdAt: 'สร้างเมื่อ',
      updatedAt: 'อัปเดตเมื่อ',
      completedAt: 'เสร็จสิ้นเมื่อ',
      reservedAt: 'สำรองเมื่อ',
      releasedAt: 'คืนยอดเมื่อ',
      sort: 'การเรียงจากเซิร์ฟเวอร์',
      evidence: 'ข้อมูลอ้างอิงหลักฐาน',
      latestAttempt: 'สรุปการส่งล่าสุดที่ปกปิด',
      version: 'เวอร์ชัน',
      events: 'เหตุการณ์สถานะ',
      idempotencyId: 'รหัสรายการ Idempotency ที่ปกปิด',
      idempotencyKey: 'คีย์ Idempotency ที่ปกปิด',
      idempotencyState: 'สถานะ Idempotency',
      responseStatus: 'สถานะการตอบกลับ',
      expiresAt: 'หมดอายุเมื่อ',
    },
    pagination: { previous: 'ก่อนหน้า', next: 'ถัดไป', loadMore: 'โหลดเพิ่มเติม' },
    detail: {
      tabsLabel: 'ส่วนตรวจสอบการถอนเงิน',
      overview: 'ภาพรวม',
      timeline: 'ไทม์ไลน์',
      attempts: 'ความพยายามส่ง',
      identity: 'ตัวตนการถอนและยอดเงิน',
      operational: 'หลักฐานการดำเนินงานที่ปกปิด',
      idempotency: 'ข้อมูลเมตา Idempotency',
      walletPostings: 'รายการกระเป๋าเงินที่แก้ไขย้อนหลังไม่ได้',
    },
    timeline: {
      empty: 'ไม่มีเหตุการณ์สถานะที่แก้ไขย้อนหลังไม่ได้',
      label: 'ไทม์ไลน์การถอนเงินที่แก้ไขย้อนหลังไม่ได้',
    },
    attempts: {
      empty: 'ไม่มีความพยายามส่งที่ปกปิดข้อมูล',
      label: 'ความพยายามส่งที่ปกปิดข้อมูล',
      attemptId: 'รหัสความพยายาม',
      attemptNumber: 'ครั้งที่',
      operation: 'การดำเนินการ',
      result: 'ผลลัพธ์',
      httpStatus: 'สถานะ HTTP',
      retryable: 'ลองซ้ำได้',
      partnerCreditId: 'รหัสเครดิตพาร์ทเนอร์ที่ปกปิด',
      error: 'สรุปข้อผิดพลาดที่ปกปิด',
      transferId: 'รหัสการโอน',
      integrationVersion: 'เวอร์ชันการเชื่อมต่อ',
      endpoint: 'ต้นทาง endpoint ที่ไม่มีข้อมูลรับรอง',
      startedAt: 'เริ่มเมื่อ',
      completedAt: 'เสร็จเมื่อ',
    },
    links: {
      member: 'สมาชิก',
      partner: 'พาร์ทเนอร์',
      agent: 'เอเจนต์',
      wallet: 'กระเป๋าเงิน',
      ledger: 'รายการบัญชีกระเป๋าเงิน',
      audit: 'กิจกรรมตรวจสอบการถอนเงิน',
    },
    errors: {
      list: 'ไม่สามารถโหลดการถอนเงิน Affiliate ได้',
      detail: 'ไม่สามารถโหลดการถอนเงิน Affiliate นี้ได้',
      events: 'ไม่สามารถโหลดเหตุการณ์การถอนเงินที่แก้ไขย้อนหลังไม่ได้',
      attempts: 'ไม่สามารถโหลดความพยายามส่งที่ปกปิดข้อมูล',
    },
  },
  withdrawalControls: {
    title: 'การควบคุมการถอนเงินของพาร์ทเนอร์',
    subtitle: 'ตรวจสอบนโยบายการถอนเงินและกฎความถี่ในอดีตสำหรับพาร์ทเนอร์ {{partnerId}}',
    backToPartner: 'กลับไปยังพาร์ทเนอร์',
    actions: {
      createPolicy: 'สร้างนโยบาย',
      activatePolicy: 'เปิดใช้งานนโยบาย',
      suspendPolicy: 'ระงับนโยบาย',
    },
    fields: {
      currency: 'สกุลเงิน',
      currencyFilter: 'กรองสกุลเงิน',
      status: 'สถานะ',
      statusFilter: 'กรองสถานะ',
      actions: 'การดำเนินการ',
      requestLimits: 'ยอดขั้นต่ำ / สูงสุดต่อคำขอ',
      minimumAmount: 'ยอดขั้นต่ำ',
      maximumAmount: 'ยอดสูงสุด',
      dailyAmountLimit: 'วงเงินต่อวัน',
      dailyCountLimit: 'จำนวนครั้งต่อวัน',
      dimension: 'มิติ',
      dimensionFilter: 'กรองมิติ',
      windowSeconds: 'ช่วงเวลา (วินาที)',
      maximumCount: 'จำนวนสูงสุด',
      reason: 'เหตุผล',
    },
    filters: { all: 'ทั้งหมด' },
    policy: {
      title: 'นโยบายการถอนเงิน',
      gridLabel: 'ตารางนโยบายการถอนเงิน',
      listNote: 'แบ่งหน้าจากเซิร์ฟเวอร์ โดย API ไม่มีลำดับเรียงที่ผู้ใช้เลือกได้',
      createTitle: 'สร้างนโยบายการถอนเงิน',
      editTitle: 'แก้ไขนโยบายการถอนเงิน',
      activateTitle: 'เปิดใช้งานนโยบายการถอนเงิน',
      suspendTitle: 'ระงับนโยบายการถอนเงิน',
      description: 'ส่งขีดจำกัดเป็นสตริงทศนิยมแบบตรงค่า และแก้ไขสกุลเงินไม่ได้หลังสร้าง',
      impact: 'ขีดจำกัดและผลกระทบของนโยบาย',
      dailyLimit: 'ขีดจำกัดต่อวัน: {{amount}} รวม {{count}} คำขอ',
      dailyLimitDisabled: 'ขีดจำกัดรายวันเดิมเก็บไว้เพื่อประวัติและไม่มีการบังคับใช้',
      platformBehaviorTitle: 'พฤติกรรมแพลตฟอร์มที่กำหนดตายตัว',
      synchronousDelivery:
        'การส่งครั้งแรก: พยายามแบบซิงโครนัส ข้อนี้เป็นพฤติกรรมแพลตฟอร์ม ไม่ใช่ฟิลด์ที่ API นโยบายส่งคืนหรือแก้ไขได้',
      confirmActivation: 'ฉันยืนยันขีดจำกัดและการเชื่อมต่อที่ผ่านการรับรอง',
      suspendImpact: 'การระงับนโยบายนี้จะบล็อกคำขอถอนใหม่สำหรับสกุลเงินของพาร์ทเนอร์นี้',
    },
    velocity: {
      title: 'กฎควบคุมความถี่',
      gridLabel: 'ตารางกฎควบคุมความถี่การถอนเงิน',
      listNote:
        'กฎในอดีตเปิดให้อ่านอย่างเดียว แบ่งหน้าจากเซิร์ฟเวอร์ตามสกุลเงินและมิติ โดย API ไม่มีลำดับเรียงที่ผู้ใช้เลือกได้',
      createTitle: 'สร้างกฎควบคุมความถี่',
      editTitle: 'แก้ไขกฎควบคุมความถี่',
      activateTitle: 'เปิดใช้งานกฎควบคุมความถี่',
      suspendTitle: 'ระงับกฎควบคุมความถี่',
      description:
        'แก้ไขสกุลเงิน มิติ และช่วงเวลาไม่ได้หลังสร้าง และต้องมีขีดจำกัดอย่างน้อยหนึ่งค่า',
      activateImpact: 'เปิดใช้งานกฎมิติ {{dimension}} เพื่อบังคับใช้',
      suspendImpact:
        'ระงับกฎมิติ {{dimension}} เซิร์ฟเวอร์จะปฏิเสธหากเป็นมิติสุดท้ายที่จำเป็นขณะนโยบายสกุลเงินเปิดใช้งาน',
    },
    errors: {
      load: 'ไม่สามารถโหลดการควบคุมการถอนเงินได้',
      mutation: 'ไม่สามารถบันทึกการเปลี่ยนแปลงการควบคุมการถอนเงินนี้ได้',
    },
  },
  commissionLedger: {
    title: 'บัญชีค่าคอมมิชชัน',
    subtitle: 'ตรวจสอบรายการค่าคอมมิชชันที่คำนวณ การปรับปรุง และข้อมูลอ้างอิงการชำระ',
    empty: 'ไม่พบรายการบัญชีค่าคอมมิชชันที่ตรงกับตัวกรอง',
    gridLabel: 'ตารางบัญชีค่าคอมมิชชัน',
    compactResultsLabel: 'ผลลัพธ์บัญชีค่าคอมมิชชันสำหรับหน้าจอขนาดเล็ก',
    actions: {
      createAdjustment: 'สร้างรายการปรับปรุง',
      applyFilters: 'ใช้ตัวกรอง',
    },
    fields: {
      entryId: 'รหัสรายการ',
      entryType: 'ประเภทรายการ',
      signedAmount: 'จำนวนเงินแบบมีเครื่องหมาย',
      currency: 'สกุลเงิน',
      beneficiary: 'ผู้รับผลประโยชน์',
      beneficiaryType: 'ประเภทผู้รับผลประโยชน์',
      beneficiaryId: 'รหัสผู้รับผลประโยชน์',
      beneficiaryUsername: 'ชื่อผู้ใช้ผู้รับผลประโยชน์',
      partner: 'พาร์ตเนอร์',
      partnerId: 'รหัสพาร์ตเนอร์',
      agent: 'เอเยนต์',
      agentId: 'รหัสเอเยนต์',
      transactionId: 'รหัสธุรกรรม',
      partnerTransactionId: 'รหัสธุรกรรมพาร์ตเนอร์',
      effectiveAt: 'เวลาที่มีผล',
      createdAt: 'เวลาที่สร้าง',
      createdBy: 'สร้างโดย',
      reasonCode: 'รหัสเหตุผล',
      reason: 'เหตุผล',
      calculationId: 'รหัสการคำนวณ',
      reversalId: 'รหัสการย้อนรายการ',
      sourceEntryId: 'รหัสรายการต้นทาง',
      approvalRequestId: 'รหัสคำขออนุมัติ',
      adjustmentId: 'รหัสรายการปรับปรุง',
      walletEntryId: 'รหัสรายการกระเป๋าเงิน',
      walletId: 'รหัสกระเป๋าเงิน',
      walletEntryType: 'ประเภทรายการกระเป๋าเงิน',
      availableDelta: 'การเปลี่ยนแปลงยอดพร้อมใช้',
      availableAfter: 'ยอดพร้อมใช้หลังรายการ',
    },
    filters: {
      minimumAmount: 'จำนวนเงินแบบมีเครื่องหมายต่ำสุด',
      maximumAmount: 'จำนวนเงินแบบมีเครื่องหมายสูงสุด',
      effectiveFrom: 'มีผลตั้งแต่ (รวมเวลานี้)',
      effectiveTo: 'มีผลก่อน (ไม่รวมเวลานี้)',
      sort: 'เวลาที่ใช้เรียงจากใหม่ไปเก่า',
      contractNote:
        'API ส่งหน้าข้อมูลแบบเคอร์เซอร์โดยเรียงเวลาจากใหม่ไปเก่าแล้วตามรหัสรายการ และไม่มีการเรียงจากเก่าไปใหม่หรือจำนวนรวม',
    },
    pagination: {
      previous: 'หน้าก่อนหน้า',
      next: 'หน้าถัดไป',
    },
    detail: {
      immutable: 'รายการนี้แก้ไขย้อนหลังไม่ได้ จึงไม่มีคำสั่งแก้ไขหรือลบ',
      overview: 'รายการบัญชี',
      source: 'ข้อมูลอ้างอิงต้นทาง',
      walletPosting: 'รายการกระเป๋าเงิน',
    },
    adjustment: {
      title: 'สร้างรายการปรับค่าคอมมิชชัน',
      description:
        'ใช้เฉพาะเวิร์กโฟลว์ข้อมูลจำลองใน DEV โดยจะสร้างคำขออนุมัติจำลองและไม่เรียก endpoint ปรับปรุงของ backend',
      unavailable:
        'API ปรับค่าคอมมิชชันยังไม่พร้อมใช้งาน โหมดข้อมูลจริงจะเป็นแบบอ่านอย่างเดียวจนกว่าจะอนุมัติ endpoint ที่ตรงกัน',
      signedAmountHelp: 'ระบุจำนวนเงินแบบมีเครื่องหมายที่ไม่เป็นศูนย์และมีทศนิยมไม่เกิน 6 หลัก',
      evidenceReference: 'ข้อมูลอ้างอิงหลักฐาน',
      impact: 'ตัวอย่างผลกระทบทางการเงิน',
      availableBefore: 'ยอดพร้อมใช้ก่อนรายการ',
      availableAfter: 'ยอดพร้อมใช้หลังรายการ',
      confirmImpact: 'ฉันยืนยันเป้าหมายและผลกระทบทางการเงินที่เสนอ',
      preview: 'ดูตัวอย่างรายการปรับปรุง',
      submit: 'ส่งคำขออนุมัติจำลอง',
      approvalCreated: 'สร้างคำขออนุมัติจำลอง {{approvalId}} แล้วและยังรอการอนุมัติ',
    },
    errors: {
      load: 'ไม่สามารถโหลดรายการบัญชีค่าคอมมิชชันได้',
      detail: 'ไม่สามารถโหลดรายการบัญชีค่าคอมมิชชันนี้ได้',
      preview: 'ไม่สามารถดูตัวอย่างรายการปรับค่าคอมมิชชันจำลองนี้ได้',
      submit: 'ไม่สามารถส่งรายการปรับค่าคอมมิชชันจำลองนี้ได้',
    },
  },
  partners: {
    title: 'พาร์ทเนอร์',
    subtitle: 'จัดการวงจรสถานะ ข้อมูลรับรอง API และการเข้าถึงเครือข่ายของพาร์ทเนอร์',
    gridLabel: 'ตารางพาร์ทเนอร์',
    empty: 'ไม่พบพาร์ทเนอร์ที่ตรงกับตัวกรอง',
    actions: {
      create: 'สร้างพาร์ทเนอร์',
      edit: 'แก้ไขพาร์ทเนอร์',
      changeStatus: 'เปลี่ยนสถานะ',
      applyFilters: 'ใช้ตัวกรอง',
    },
    fields: {
      code: 'รหัสพาร์ทเนอร์',
      name: 'ชื่อพาร์ทเนอร์',
      affiliateCommissionExpiry: 'อายุค่าคอมมิชชันแอฟฟิลิเอต (วัน)',
      status: 'สถานะ',
      proposedStatus: 'สถานะใหม่',
      currency: 'สกุลเงิน',
      timezone: 'เขตเวลา',
      usernameNormalization: 'การปรับรูปแบบชื่อผู้ใช้',
      requestRateLimit: 'ขีดจำกัดคำขอ / นาที',
      withdrawalRateLimit: 'ขีดจำกัดการถอน / นาที',
      timestampTolerance: 'ค่าคลาดเคลื่อนเวลา (วินาที)',
      createdAt: 'สร้างเมื่อ',
      updatedAt: 'อัปเดตเมื่อ',
      reason: 'เหตุผล',
    },
    filters: {
      code: 'รหัสพาร์ทเนอร์',
      name: 'ชื่อพาร์ทเนอร์',
      status: 'สถานะ',
      currency: 'สกุลเงิน',
    },
    validation: {
      codeRequired: 'ต้องระบุรหัสพาร์ทเนอร์',
      codeInvalid: 'ใช้ตัวอักษร ตัวเลข ขีดล่าง หรือขีดกลาง 2–32 ตัว',
      nameRequired: 'ต้องระบุชื่อพาร์ทเนอร์',
      currencyRequired: 'ต้องระบุสกุลเงิน',
      currencyInvalid: 'ใช้รหัสสกุลเงินสามตัวอักษร',
      timezoneRequired: 'ต้องระบุเขตเวลา',
      reasonRequired: 'ต้องระบุเหตุผล',
      positive: 'กรอกค่าตั้งแต่ 1 ขึ้นไป',
      nonNegative: 'กรอกค่าศูนย์หรือค่าบวก',
      toleranceMaximum: 'ค่าคลาดเคลื่อนสูงสุดคือ 3600 วินาที',
      expiryRange: 'กรอก 1–365 วัน หรือเว้นว่างเพื่อไม่ให้หมดอายุ',
    },
    form: {
      createTitle: 'สร้างพาร์ทเนอร์',
      editTitle: 'แก้ไขพาร์ทเนอร์',
      affiliateCommissionExpiryHelp: 'ใช้กับค่าคอมมิชชันล็อตใหม่ เว้นว่างหากไม่ต้องการให้หมดอายุ',
    },
    errors: {
      load: 'ไม่สามารถโหลดพาร์ทเนอร์ได้',
      detail: 'ไม่สามารถโหลดพาร์ทเนอร์นี้ได้',
      mutation: 'ไม่สามารถบันทึกการเปลี่ยนแปลงพาร์ทเนอร์ได้',
    },
    status: {
      title: 'เปลี่ยนสถานะพาร์ทเนอร์',
      impact: '{{code}} จะเปลี่ยนจาก {{current}} เป็น {{next}}',
      closedTerminal: 'สถานะ CLOSED เป็นสถานะสุดท้ายและย้อนกลับไม่ได้',
    },
    detail: {
      tabsLabel: 'ส่วนรายละเอียดพาร์ทเนอร์',
      overview: 'ภาพรวม',
      expiryDays: '{{count}} วัน',
      neverExpires: 'ไม่หมดอายุ',
      related: 'งานที่เกี่ยวข้อง',
      gameAvailability: 'การเปิดใช้เกม',
      withdrawalControls: 'การควบคุมการถอนเงิน',
      partnerCredit: 'เครดิตพาร์ทเนอร์',
      audit: 'บันทึกตรวจสอบ',
    },
    credentials: {
      title: 'ข้อมูลรับรอง',
      safeMetadata: 'จัดเก็บและแสดงเฉพาะข้อมูลเมตาที่ปลอดภัยของข้อมูลรับรอง',
      empty: 'ยังไม่มีการออกข้อมูลรับรอง API',
      loadError: 'ไม่สามารถโหลดข้อมูลรับรองพาร์ทเนอร์ได้',
      mutationError: 'ไม่สามารถอัปเดตข้อมูลรับรองนี้ได้',
      issue: 'ออกข้อมูลรับรอง',
      issueTitle: 'ออกข้อมูลรับรอง API',
      issueVerb: 'ออกข้อมูลรับรอง',
      secretWarning: 'จะแสดง Secret เพียงครั้งเดียวหลังออกข้อมูลรับรองสำเร็จ',
      keyId: 'รหัสคีย์',
      validFrom: 'ใช้ได้ตั้งแต่',
      expiresAt: 'หมดอายุเมื่อ',
      expiresAtOptional: 'หมดอายุเมื่อ (เวลา ISO ไม่บังคับ)',
      lastUsedAt: 'ใช้ล่าสุด',
      actions: 'การดำเนินการ',
      rotate: 'หมุนเวียน',
      expiry: 'เปลี่ยนวันหมดอายุ',
      revoke: 'เพิกถอน',
      rotateTitle: 'หมุนเวียนข้อมูลรับรอง',
      rotateImpact: 'จะออกข้อมูลรับรองใหม่สำหรับ {{keyId}} และข้อมูลเดิมยังใช้งานได้',
      revokeTitle: 'เพิกถอนข้อมูลรับรอง',
      revokeImpact: '{{keyId}} จะถูกเพิกถอนอย่างถาวร',
      expiryTitle: 'เปลี่ยนวันหมดอายุข้อมูลรับรอง',
      expiryRequired: 'ต้องระบุวันหมดอายุ',
      oneTimeTitle: 'Secret ข้อมูลรับรองแบบครั้งเดียว',
      oneTimeWarning: 'คัดลอก Secret ตอนนี้ เพราะจะเรียกดูอีกไม่ได้',
      copyError: 'คัดลอก Secret ไม่สำเร็จ โปรดเลือกและคัดลอกเองแล้วกดยืนยัน',
      discarded: 'ฉันตั้งใจละทิ้ง Secret นี้',
      copyClose: 'คัดลอกและปิด',
      acknowledgeClose: 'รับทราบและปิด',
    },
    ip: {
      title: 'รายการ IP ที่อนุญาต',
      unrestrictedWarning: 'หากไม่มีรายการที่ใช้งาน การเข้าถึง Partner API ในอนาคตจะไม่จำกัด IP',
      empty: 'ยังไม่ได้กำหนดรายการ IP ที่อนุญาต',
      loadError: 'ไม่สามารถโหลดรายการ IP ที่อนุญาตได้',
      mutationError: 'ไม่สามารถอัปเดตรายการ IP ที่อนุญาตได้',
      add: 'เพิ่มเครือข่าย',
      network: 'เครือข่าย',
      description: 'คำอธิบาย',
      actions: 'การดำเนินการ',
      createTitle: 'เพิ่มรายการ IP ที่อนุญาต',
      editTitle: 'แก้ไขรายการ IP ที่อนุญาต',
      networkRequired: 'ต้องระบุเครือข่าย',
      descriptionRequired: 'ต้องระบุคำอธิบาย',
      statusTitle: 'เปลี่ยนสถานะรายการ IP ที่อนุญาต',
      statusImpact: '{{network}} จะเปลี่ยนจาก {{current}} เป็น {{next}}',
    },
  },
  agents: {
    title: 'เอเจนต์',
    subtitle: 'จัดการวงจรสถานะ บริบทการกำหนดสมาชิก และอัปไลน์เริ่มต้นของเอเจนต์',
    empty: 'ไม่พบเอเจนต์ที่ตรงกับตัวกรอง',
    gridLabel: 'ตารางเอเจนต์',
    actions: {
      create: 'สร้างเอเจนต์',
      edit: 'แก้ไขเอเจนต์',
      changeStatus: 'เปลี่ยนสถานะ',
      changeUpline: 'เปลี่ยนอัปไลน์เริ่มต้น',
      createHouse: 'สร้างสมาชิกเฮาส์',
      applyFilters: 'ใช้ตัวกรอง',
    },
    fields: {
      partner: 'พาร์ทเนอร์',
      partnerId: 'รหัสพาร์ทเนอร์',
      code: 'รหัสเอเจนต์',
      name: 'ชื่อเอเจนต์',
      contact: 'ข้อมูลติดต่อ JSON',
      status: 'สถานะ',
      proposedStatus: 'สถานะใหม่',
      currency: 'สกุลเงินเริ่มต้น',
      userCount: 'ผู้ใช้',
      activeUserCount: 'ผู้ใช้ที่ใช้งาน',
      defaultUpline: 'อัปไลน์เริ่มต้น',
      memberId: 'รหัสสมาชิก',
      username: 'ชื่อผู้ใช้',
      partnerUserId: 'รหัสผู้ใช้พาร์ทเนอร์ (ไม่บังคับ)',
      createdAt: 'สร้างเมื่อ',
      updatedAt: 'อัปเดตล่าสุด',
      reason: 'เหตุผล',
    },
    filters: {
      partnerId: 'รหัสพาร์ทเนอร์',
      code: 'รหัสเอเจนต์',
      name: 'ชื่อเอเจนต์',
      status: 'สถานะ',
    },
    validation: {
      partnerRequired: 'ต้องระบุรหัสพาร์ทเนอร์',
      codeRequired: 'ต้องระบุรหัสเอเจนต์',
      codeInvalid: 'ใช้ตัวอักษร ตัวเลข ขีดล่าง หรือขีดกลาง 2–32 ตัว',
      nameRequired: 'ต้องระบุชื่อเอเจนต์',
      contactInvalid: 'ข้อมูลติดต่อต้องเป็นออบเจ็กต์ JSON',
      memberRequired: 'ต้องระบุรหัสสมาชิก',
      usernameRequired: 'ต้องระบุชื่อผู้ใช้',
      reasonRequired: 'ต้องระบุเหตุผล',
    },
    form: {
      createTitle: 'สร้างเอเจนต์',
      editTitle: 'แก้ไขเอเจนต์',
      contactHelp: 'กรอกออบเจ็กต์ JSON โดยใช้เฉพาะข้อมูลติดต่อที่อนุมัติแล้ว',
    },
    errors: {
      load: 'ไม่สามารถโหลดเอเจนต์ได้',
      detail: 'ไม่สามารถโหลดเอเจนต์นี้ได้',
      mutation: 'ไม่สามารถบันทึกการเปลี่ยนแปลงเอเจนต์ได้',
      houseMember: 'ไม่สามารถสร้างสมาชิกเฮาส์ได้',
    },
    status: {
      title: 'เปลี่ยนสถานะเอเจนต์',
      impact:
        '{{code}} จะเปลี่ยนจาก {{current}} เป็น {{next}} ขณะนี้เอเจนต์มีผู้ใช้ที่ใช้งาน {{activeUsers}} คน',
      activeUserBlock: 'การปิดใช้งานต้องไม่มีผู้ใช้ NORMAL ที่ใช้งานอยู่',
      closedTerminal: 'สถานะ CLOSED เป็นสถานะสุดท้ายและย้อนกลับไม่ได้',
    },
    upline: {
      title: 'เปลี่ยนอัปไลน์เริ่มต้น',
      confirmation: 'ยืนยันรหัสสมาชิกที่เลือกและเหตุผลก่อนส่งข้อมูล',
    },
    house: {
      title: 'สร้างสมาชิกเฮาส์',
      impact:
        'การดำเนินการนี้สร้างสมาชิก HOUSE สถานะ ACTIVE ให้ {{code}} และไม่เปลี่ยนอัปไลน์เริ่มต้น',
    },
    detail: {
      overview: 'ภาพรวม',
      related: 'ข้อมูลที่เกี่ยวข้อง',
      partner: 'พาร์ทเนอร์',
      members: 'สมาชิก',
      transactions: 'ธุรกรรม',
      commissionReports: 'รายงานค่าคอมมิชชัน',
    },
  },
  members: {
    title: 'สมาชิกและผู้แนะนำ',
    subtitle: 'ติดตามโปรไฟล์สมาชิก ความสัมพันธ์การแนะนำ และการระบุแหล่งที่มาของแอฟฟิลิเอต',
    empty: 'ไม่พบสมาชิกที่ตรงกับตัวกรอง',
    gridLabel: 'ตารางสมาชิก',
    contractNote:
      'Members API ไม่ได้ให้ข้อมูลกิจกรรม ยอดเล่น ค่าคอมมิชชันที่สร้าง หรือสถานะการถอนเงิน',
    actions: {
      applyFilters: 'ใช้ตัวกรอง',
      changeAssignment: 'เปลี่ยนการกำหนด',
      rotateReferral: 'หมุนเวียนรหัสแนะนำ',
      changeStatus: 'เปลี่ยนสถานะ',
      bindPartnerUser: 'ผูกรหัสผู้ใช้พาร์ทเนอร์',
      preview: 'ดูตัวอย่างการเปลี่ยนแปลง',
      submitAssignment: 'ส่งการเปลี่ยนแปลง',
      cancelChangeSet: 'ยกเลิกชุดการเปลี่ยนแปลง',
    },
    fields: {
      username: 'ชื่อผู้ใช้',
      partnerUserId: 'รหัสผู้ใช้พาร์ทเนอร์',
      partner: 'พาร์ทเนอร์',
      agent: 'เอเจนต์',
      upline: 'อัปไลน์',
      directUpline: 'อัปไลน์โดยตรง',
      referralCode: 'รหัสแนะนำ',
      status: 'สถานะ',
      proposedStatus: 'สถานะใหม่',
      type: 'ประเภทสมาชิก',
      registeredAt: 'ลงทะเบียนเมื่อ',
      downlines: 'ดาวน์ไลน์โดยตรง',
      wallet: 'ยอดกระเป๋าพร้อมใช้',
      walletStatus: 'สถานะกระเป๋า',
      available: 'ยอดพร้อมใช้',
      reserved: 'ยอดสำรอง',
      assignmentType: 'ประเภทการกำหนด',
      agentDefaultUpline: 'อัปไลน์เริ่มต้นของเอเจนต์',
      effectiveAt: 'มีผลเมื่อ',
      reason: 'เหตุผล',
      createdAt: 'สร้างเมื่อ',
      updatedAt: 'อัปเดตล่าสุด',
    },
    filters: {
      username: 'ชื่อผู้ใช้',
      partnerId: 'รหัสพาร์ทเนอร์',
      agentId: 'รหัสเอเจนต์',
      uplineId: 'รหัสสมาชิกอัปไลน์',
      partnerUserId: 'รหัสผู้ใช้พาร์ทเนอร์',
      referralCode: 'รหัสแนะนำ',
      type: 'ประเภทสมาชิก',
      status: 'สถานะ',
    },
    validation: {
      reasonRequired: 'ต้องระบุเหตุผล',
      partnerUserRequired: 'ต้องระบุรหัสผู้ใช้พาร์ทเนอร์',
      agentRequired: 'ต้องระบุเอเจนต์',
      uplineRequired: 'ต้องระบุอัปไลน์',
      effectiveRequired: 'ต้องระบุเวลาที่มีผล',
      futureRequired: 'เวลาที่มีผลต้องอยู่ในอนาคต',
    },
    errors: {
      load: 'ไม่สามารถโหลดสมาชิกได้',
      detail: 'ไม่สามารถโหลดสมาชิกนี้ได้',
      downlines: 'ไม่สามารถโหลดดาวน์ไลน์โดยตรงได้',
      assignments: 'ไม่สามารถโหลดประวัติการกำหนดได้',
      mutation: 'ไม่สามารถบันทึกการเปลี่ยนแปลงสมาชิกได้',
      binding: 'ไม่สามารถผูกตัวตน HOUSE นี้ได้',
      preview: 'ไม่สามารถดูตัวอย่างการเปลี่ยนการกำหนดได้',
      assignment: 'ไม่สามารถสร้างชุดการเปลี่ยนการกำหนดได้',
      changeSet: 'ไม่สามารถโหลดชุดการเปลี่ยนการกำหนดนี้ได้',
      cancelChangeSet: 'ไม่สามารถยกเลิกชุดการเปลี่ยนการกำหนดนี้ได้',
    },
    detail: {
      tabsLabel: 'ส่วนรายละเอียดสมาชิก',
      overview: 'ภาพรวม',
      downlines: 'ดาวน์ไลน์โดยตรง',
      assignments: 'ประวัติการกำหนด',
      related: 'ข้อมูลที่เกี่ยวข้อง',
      transactions: 'ธุรกรรม',
      wallets: 'กระเป๋าเงิน',
      withdrawals: 'การถอนเงิน',
      audit: 'บันทึกตรวจสอบ',
    },
    binding: {
      title: 'ผูกตัวตน HOUSE',
      impact:
        'การดำเนินการนี้จะผูก {{username}} กับรหัสผู้ใช้ NewPortal หนึ่งรายการอย่างถาวร โปรดตรวจสอบตัวตนข้ามระบบก่อนบันทึก',
    },
    downlines: {
      directOnly: 'เฉพาะดาวน์ไลน์โดยตรงเท่านั้นที่ได้รับค่าคอมมิชชันแอฟฟิลิเอต',
      deeper: 'ระดับการแนะนำที่ลึกกว่านี้ไม่ได้รับค่าคอมมิชชัน',
      empty: 'สมาชิกนี้ไม่มีดาวน์ไลน์โดยตรงในปัจจุบัน',
      gridLabel: 'ตารางดาวน์ไลน์โดยตรง',
    },
    assignments: {
      empty: 'ไม่มีประวัติการกำหนด',
      timelineNote: 'ประวัติมีวันที่มีผลและแสดงออฟเซ็ตเวลาเดิม',
      changeSet: 'เปิดชุดการเปลี่ยนแปลง',
    },
    assignment: {
      title: 'เปลี่ยนการกำหนดสมาชิก',
      impact: '{{member}} จะย้ายไปยังเอเจนต์และอัปไลน์โดยตรงใหม่ตามเวลาที่มีผลในอนาคต',
      futureOnly: 'การเปลี่ยนการกำหนดต้องมีผลในอนาคต',
      previewHash: 'แฮชตัวอย่าง',
      previewChanges: 'รายการเปลี่ยนแปลงจากพรีวิวเซิร์ฟเวอร์',
      previewChangesLabel: 'รายการเปลี่ยนแปลงการกำหนดสมาชิกในพรีวิว',
      memberId: 'รหัสสมาชิก',
      beforeAgent: 'ก่อนเปลี่ยน · รหัสเอเจนต์',
      beforeUpline: 'ก่อนเปลี่ยน · รหัสสมาชิกอัปไลน์',
      afterAgent: 'หลังเปลี่ยน · รหัสเอเจนต์',
      afterUpline: 'หลังเปลี่ยน · รหัสสมาชิกอัปไลน์',
      previewBound: 'แฮชทึบนี้ผูกข้อมูลที่ปรับมาตรฐานกับสถานะการพึ่งพาปัจจุบันของเซิร์ฟเวอร์',
      confirm: 'ฉันยืนยันการเปลี่ยนการกำหนดนี้และผลกระทบที่แสดงอย่างชัดเจน',
      expired: 'ตัวอย่างหมดอายุเพราะข้อมูลเปลี่ยน โปรดดูตัวอย่างใหม่ก่อนส่ง',
    },
    referral: {
      title: 'หมุนเวียนรหัสแนะนำ',
      impact: '{{code}} จะถูกเพิกถอนและแทนที่อย่างถาวร',
      relationships: 'ความสัมพันธ์การแนะนำที่มีอยู่จะไม่เปลี่ยนแปลง',
    },
    status: {
      title: 'เปลี่ยนสถานะสมาชิก',
      impact: '{{username}} จะเปลี่ยนจาก {{current}} เป็น {{next}}',
      closedTerminal: 'สถานะ CLOSED เป็นสถานะสุดท้ายและย้อนกลับไม่ได้',
    },
    changeSet: {
      title: 'ชุดการเปลี่ยนการกำหนด {{id}}',
      status: 'สถานะ',
      mode: 'โหมด',
      createdAt: 'สร้างเมื่อ',
      items: 'การเปลี่ยนสมาชิก',
      cancelTitle: 'ยกเลิกชุดการเปลี่ยนการกำหนด',
      cancelImpact:
        '{{id}} จะเปลี่ยนจาก {{current}} เป็น {{next}} และคืนช่วงเวลาก่อนหน้าอย่างถูกต้อง',
      elapsed: 'ไม่สามารถยกเลิกชุดการเปลี่ยนแปลงนี้ได้แล้ว เนื่องจากเลยเวลามีผล',
    },
  },
  adminUsers: {
    title: 'ผู้ใช้ระบบหลังบ้าน',
    subtitle: 'จัดการตัวตน บทบาท ขอบเขต และโปรไฟล์สิทธิ์ของระบบหลังบ้าน',
    empty: 'ไม่พบผู้ใช้ระบบหลังบ้านที่ตรงกับตัวกรอง',
    gridLabel: 'ตารางผู้ใช้ระบบหลังบ้าน',
    actions: {
      invite: 'เชิญผู้ใช้',
      edit: 'แก้ไขผู้ใช้',
      editAccess: 'แก้ไขสิทธิ์เข้าถึง',
      changeStatus: 'เปลี่ยนสถานะ',
    },
    fields: {
      subject: 'รหัสตัวตน IAM',
      username: 'ชื่อผู้ใช้',
      displayName: 'ชื่อที่แสดง',
      email: 'อีเมล',
      role: 'บทบาท',
      status: 'สถานะ',
      proposedStatus: 'สถานะที่เสนอ',
      partnerId: 'รหัสพาร์ทเนอร์',
      agentId: 'รหัสเอเจนต์',
      profile: 'โปรไฟล์สิทธิ์',
      profileId: 'รหัสโปรไฟล์สิทธิ์',
      permissions: 'สิทธิ์',
      assignedUsers: 'ผู้ใช้ที่ได้รับผลกระทบ',
      lastLogin: 'เข้าสู่ระบบล่าสุด',
      updatedAt: 'อัปเดตเมื่อ',
      reason: 'เหตุผล',
      actions: 'การดำเนินการ',
    },
    access: {
      title: 'แก้ไขสิทธิ์ผู้ใช้',
      impact: '{{name}} มีบทบาท {{role}} อยู่ โปรดยืนยันบทบาทและขอบเขตใหม่',
      selfBlocked: 'คุณไม่สามารถเปลี่ยนบทบาทหรือขอบเขตของตนเอง และไม่สามารถเปลี่ยนสถานะของตนเองได้',
      roleManaged: 'กำหนดโดยบทบาท Super Admin',
      profileManaged: 'กำหนดโดยโปรไฟล์สิทธิ์ที่ได้รับมอบหมาย',
      roleGrants: 'สิทธิ์จากบทบาท',
      roleGrantsUnavailable:
        'เซิร์ฟเวอร์เป็นผู้คำนวณสิทธิ์จากบทบาท และ API contract นี้ไม่ได้ส่งรายการดังกล่าว',
      profileGrants: 'สิทธิ์จากโปรไฟล์ที่ได้รับมอบหมาย',
      noProfileGrants: 'ไม่ได้กำหนดโปรไฟล์สิทธิ์ให้ผู้ใช้นี้',
    },
    status: {
      impact: '{{name}} มีสถานะ {{status}} การเปลี่ยนนี้มีผลต่อการเข้าถึงทันที',
    },
    profiles: {
      title: 'โปรไฟล์สิทธิ์',
      subtitle: 'จัดการชุดสิทธิ์ที่มอบหมายได้ภายในขอบเขตเอเจนต์',
      empty: 'ไม่พบโปรไฟล์สิทธิ์ที่ตรงกับตัวกรอง',
      gridLabel: 'ตารางโปรไฟล์สิทธิ์',
      create: 'สร้างโปรไฟล์',
      edit: 'แก้ไขโปรไฟล์สิทธิ์',
      catalog: 'รายการสิทธิ์แยกตามโดเมน',
      delegableOnly: 'กำหนดได้เฉพาะสิทธิ์ที่ API ระบุว่าสามารถมอบหมายได้',
      sensitive: 'มีความละเอียดอ่อน',
      notDelegable: 'มอบหมายไม่ได้',
      affected: 'ผู้ใช้ที่ได้รับผลกระทบ {{count}} คน',
      statusImpact: 'โปรไฟล์จะเปลี่ยนจาก {{current}} เป็น {{next}}',
      domains: {
        audit: 'การตรวจสอบ',
        member: 'สมาชิก',
        transaction: 'ธุรกรรม',
        wallet: 'กระเป๋าเงิน',
      },
    },
    security: {
      title: 'ความปลอดภัย',
      resetMfa: 'รีเซ็ต MFA (จำลอง)',
      mockDescription:
        'ยังไม่มี API สำหรับรีเซ็ต MFA ในสัญญาปัจจุบัน นี่เป็นเพียงการจำลองเพื่อสาธิตเท่านั้นและจะไม่ส่งคำขอใด ๆ',
      mockAcknowledged: 'บันทึกการดำเนินการจำลองไว้ในเครื่องเท่านั้น ไม่มีการส่งคำขอไปยังบริการใด',
      identityProviderManaged:
        'MFA อยู่ภายใต้การจัดการของผู้ให้บริการข้อมูลประจำตัว และไม่สามารถรีเซ็ตได้จากคอนโซลนี้',
    },
    validation: { required: 'กรุณาระบุข้อมูลนี้' },
    errors: {
      load: 'ไม่สามารถโหลดผู้ใช้ระบบหลังบ้านได้',
      detail: 'ไม่สามารถโหลดผู้ใช้ระบบหลังบ้านรายนี้ได้',
      mutation: 'ไม่สามารถบันทึกการเปลี่ยนแปลงผู้ใช้ระบบหลังบ้านได้',
      profiles: 'ไม่สามารถโหลดโปรไฟล์สิทธิ์ได้',
      profileDetail: 'ไม่สามารถโหลดโปรไฟล์สิทธิ์ที่ได้รับมอบหมายได้',
      profileMutation: 'ไม่สามารถบันทึกการเปลี่ยนแปลงโปรไฟล์สิทธิ์ได้',
    },
  },
  transactions: {
    title: 'ธุรกรรม',
    subtitle: 'ตรวจสอบหลักฐานธุรกรรม การระบุความสัมพันธ์ การคำนวณ และการลงบัญชีแบบแก้ไขไม่ได้',
    empty: 'ไม่พบธุรกรรมที่ตรงกับตัวกรอง',
    gridLabel: 'ตารางผลลัพธ์ธุรกรรม',
    compactResultsLabel: 'ผลลัพธ์ธุรกรรม',
    serverOrder: 'ผลลัพธ์คงลำดับจากเซิร์ฟเวอร์ และแบ่งหน้าด้วยเคอร์เซอร์แบบทึบเท่านั้น',
    actions: { applyFilters: 'ใช้ตัวกรอง' },
    pagination: { previous: 'ก่อนหน้า', next: 'ถัดไป' },
    errors: { list: 'ไม่สามารถโหลดธุรกรรมได้', detail: 'ไม่สามารถโหลดธุรกรรมนี้ได้' },
    fields: {
      partner: 'พาร์ทเนอร์',
      partnerId: 'รหัสพาร์ทเนอร์',
      agentId: 'รหัสเอเจนต์',
      memberId: 'รหัสสมาชิก',
      username: 'ชื่อผู้ใช้',
      partnerUserId: 'รหัสผู้ใช้ของพาร์ทเนอร์',
      uplineMemberId: 'รหัสสมาชิกสายบน',
      uplineUsername: 'ชื่อผู้ใช้สายบน',
      gameTypeId: 'รหัสประเภทเกม',
      gameTypeCode: 'รหัสย่อประเภทเกม',
      gameId: 'รหัสเกม',
      gameCode: 'รหัสย่อเกม',
      gameRound: 'รอบเกม',
      transactionId: 'รหัสธุรกรรม',
      partnerTransactionId: 'รหัสธุรกรรมพาร์ทเนอร์',
      outcome: 'ผลลัพธ์',
      status: 'สถานะ',
      reversalState: 'สถานะย้อนรายการ',
      currency: 'สกุลเงิน',
      errorCode: 'รหัสข้อผิดพลาด',
      minimumAmount: 'ยอดเล่นขั้นต่ำ',
      maximumAmount: 'ยอดเล่นสูงสุด',
      playFrom: 'เวลาเล่นตั้งแต่ (RFC3339)',
      playTo: 'เวลาเล่นถึง (RFC3339)',
      receivedFrom: 'เวลารับตั้งแต่ (RFC3339)',
      receivedTo: 'เวลารับถึง (RFC3339)',
      sort: 'การเรียงจากเซิร์ฟเวอร์',
      actualPlayAmount: 'ยอดเล่นจริง',
      winLossAmount: 'ยอดชนะ/แพ้',
      playAt: 'เวลาเล่น',
      receivedAt: 'เวลารับ',
      rule: 'กฎค่าคอมมิชชัน',
      assignmentId: 'รหัสการกำหนด',
      agentFormula: 'สูตรเอเจนต์',
      affiliateFormula: 'สูตรแอฟฟิลิเอต',
      totalCommission: 'ค่าคอมมิชชันรวม',
      roundingMode: 'วิธีปัดเศษ',
      calculatedAt: 'เวลาคำนวณ',
      calculatedBy: 'คำนวณโดย',
      trace: 'ข้อมูลติดตามที่ปลอดภัย',
      failureCode: 'รหัสความล้มเหลว',
      failureSummary: 'สรุปความล้มเหลวที่ปลอดภัย',
      idempotencyId: 'รหัสระเบียน Idempotency',
      idempotencyKey: 'คีย์ Idempotency (ปกปิดแบบย้อนกลับไม่ได้)',
      idempotencyState: 'สถานะ Idempotency',
      responseStatus: 'สถานะการตอบกลับ',
      createdAt: 'สร้างเมื่อ',
      completedAt: 'เสร็จเมื่อ',
      expiresAt: 'หมดอายุเมื่อ',
      audit: 'การตรวจสอบ',
    },
    detail: {
      immutable: 'การตรวจสอบธุรกรรมแบบอ่านอย่างเดียว',
      requestId: 'รหัสคำขอ',
      overview: 'ภาพรวม',
      relationshipSnapshot: 'ภาพความสัมพันธ์ ณ เวลาทำรายการ',
      unresolved: 'ไม่มีข้อมูลการระบุความสัมพันธ์',
      calculation: 'การคำนวณค่าคอมมิชชัน',
      noCalculation: 'ธุรกรรมนี้ไม่มีการคำนวณค่าคอมมิชชัน',
      ruleVersion: 'กฎเวอร์ชัน {{version}}',
      ledgerSources: 'แหล่งบัญชีและกระเป๋าเงิน',
      ledgerEntry: 'รายการบัญชี · {{id}}',
      walletLink: 'กระเป๋าเงิน · {{id}}',
      reversalChain: 'ความสัมพันธ์การย้อนรายการ',
      reversalContractNote:
        'API มีเฉพาะธุรกรรมปัจจุบัน รายการย้อนที่เชื่อมโยงหนึ่งรายการ และแหล่งบัญชีที่เกี่ยวข้อง โดยไม่มี endpoint ประวัติย้อนรายการหลายทอด',
      originalTransaction: 'ธุรกรรมต้นฉบับ · {{id}}',
      notReversed: 'ไม่มีรายการย้อนที่เชื่อมโยง',
      requestTrace: 'ข้อมูลติดตามคำขอและ Idempotency',
      safeMetadata:
        'API เก็บฟิลด์ metadata ที่ปลอดภัย {{count}} ฟิลด์ โดยจะไม่แสดง payload, header, credential, token หรือ hash ดิบ',
      partnerLink: 'พาร์ทเนอร์ · {{name}}',
      agentLink: 'เอเจนต์ · {{code}}',
      memberLink: 'สมาชิก · {{username}}',
      gameLink: 'เกม · {{code}}',
      auditLink: 'ประวัติตรวจสอบธุรกรรม',
    },
    reversal: {
      action: 'ย้อนรายการด้วยตนเอง',
      title: 'ย้อนธุรกรรมด้วยตนเอง',
      description:
        'สร้างคำขออนุมัติจำลองเฉพาะ DEV สำหรับรายการชดเชย โดยธุรกรรมต้นฉบับยังคงแก้ไขไม่ได้',
      impact: 'ผลกระทบจากการย้อนรายการ',
      transactionState: 'สถานะธุรกรรม',
      signedImpact: 'ผลกระทบแบบมีเครื่องหมายที่คำนวณแล้ว',
      dualControl: 'แนะนำการควบคุมสองบุคคล โดยให้ผู้ปฏิบัติงานที่มีสิทธิ์อีกคนเป็นผู้ตัดสินคำขอนี้',
      ineligible: 'การย้อนรายการด้วยตนเองต้องเป็นธุรกรรมที่คำนวณแล้วและยังไม่ถูกย้อนรายการ',
      confirmImpact: 'ฉันยืนยันสถานะธุรกรรมและผลกระทบทางการเงินที่แสดง',
      submit: 'ส่งคำขออนุมัติจำลอง',
      approvalCreated: 'คำขออนุมัติจำลอง {{approvalId}} กำลังรอการตัดสินจากบุคคลอื่น',
      error: 'ไม่สามารถสร้างคำขออนุมัติการย้อนรายการจำลองได้',
    },
  },
  transactionFailures: {
    title: 'คิวธุรกรรมล้มเหลว',
    subtitle: 'ตรวจสอบกลุ่มความล้มเหลวในการส่งธุรกรรมและหลักฐานคำขอที่ปลอดภัย',
    mockOnly: 'คิวนี้ใช้ข้อมูลจำลอง DEV แบบคงที่ เนื่องจากความสามารถฝั่ง backend ยังไม่พร้อมใช้งาน',
    empty: 'ไม่มีรายการส่งที่ล้มเหลวตรงกับมุมมองนี้',
    tableLabel: 'คิวธุรกรรมล้มเหลว',
    errors: {
      load: 'ไม่สามารถโหลดคิวธุรกรรมล้มเหลวได้',
    },
    fields: {
      errorCode: 'รหัสข้อผิดพลาด',
      fieldErrors: 'ข้อผิดพลาดรายฟิลด์',
      partner: 'พาร์ทเนอร์',
      firstOccurrence: 'เกิดครั้งแรก',
      lastOccurrence: 'เกิดครั้งล่าสุด',
      retryCount: 'จำนวนครั้งที่ลองซ้ำ',
      supportNotes: 'บันทึกฝ่ายสนับสนุน',
      requestId: 'รหัสคำขอ',
    },
  },
  apiOperations: {
    title: 'การดำเนินงาน API',
    subtitle: 'ติดตามสุขภาพคำขอและตรวจสอบรายการส่งจากพาร์ทเนอร์ที่ล้มเหลว',
    errors: {
      load: 'ไม่สามารถโหลดข้อมูลการดำเนินงาน API ได้',
    },
    filters: { endpoint: 'Endpoint', statusClass: 'กลุ่มสถานะ' },
    metrics: {
      label: 'ตัวชี้วัดการดำเนินงาน API',
      requestVolume: 'ปริมาณคำขอ',
      errorRate: 'อัตราข้อผิดพลาด',
      p50Latency: 'เวลาแฝง P50',
      p95Latency: 'เวลาแฝง P95',
      p99Latency: 'เวลาแฝง P99',
    },
    failures: {
      label: 'รายการส่งที่ล้มเหลว',
      status: 'สถานะ',
      partner: 'พาร์ทเนอร์',
      errorCode: 'รหัสข้อผิดพลาด',
      occurredAt: 'เกิดเมื่อ',
      requestId: 'รหัสคำขอ',
    },
  },
  reconciliation: {
    title: 'การกระทบยอด',
    subtitle: 'เปรียบเทียบข้อมูลแพลตฟอร์มกับยอดผู้ให้บริการและระบุข้อยกเว้นการกระทบยอด',
    tabs: { label: 'มุมมองการกระทบยอด', runs: 'รอบตรวจสอบ', exceptions: 'ข้อยกเว้น' },
    actions: {
      createRun: 'สร้างรอบกระทบยอด',
      queueRun: 'เข้าคิวรอบตรวจสอบ',
      resolveException: 'แก้ไขข้อยกเว้น',
      acknowledgeException: 'รับทราบข้อบกพร่องเดิม',
      viewExceptions: 'ดูข้อยกเว้นการกระทบยอด',
    },
    pagination: { previous: 'ก่อนหน้า', next: 'ถัดไป' },
    runsTable: 'รอบการกระทบยอด',
    exceptionsTable: 'ข้อยกเว้นการกระทบยอด',
    compactRuns: 'รอบการกระทบยอดแบบย่อ',
    compactExceptions: 'ข้อยกเว้นการกระทบยอดแบบย่อ',
    emptyRuns: 'ไม่มีรอบการกระทบยอดตรงกับตัวกรอง',
    emptyExceptions: 'ไม่มีข้อยกเว้นตรงกับตัวกรอง',
    allPartners: 'พาร์ทเนอร์ทั้งหมด',
    createImpact:
      'การดำเนินการนี้จะเข้าคิวเปรียบเทียบทางการเงินแบบอะซิงโครนัส และไม่เปลี่ยนยอดคงเหลือ',
    resolveImpact:
      'การแก้ไขจะตรวจสอบหลักฐานซ้ำและบันทึกข้อยกเว้นที่สะอาด โดยไม่ซ่อมแซมสถานะทางการเงิน',
    acknowledgeImpact:
      'การรับทราบจะเก็บประวัติที่แก้ไขไม่ได้และบันทึกหลักฐานภายนอกที่ตรวจสอบแล้ว โดยไม่เปลี่ยนยอดคงเหลือหรือรายการบัญชี',
    confirmResolution: 'ฉันยืนยันว่าหลักฐานรองรับการแก้ไขข้อยกเว้นนี้',
    confirmAcknowledgement:
      'ฉันยืนยันว่านี่คือข้อบกพร่องของสายบัญชีในอดีตที่ตรวจสอบแล้ว และกระเป๋าปัจจุบันกระทบยอดถูกต้อง',
    noResolution: 'ข้อยกเว้นนี้ยังไม่ได้รับการแก้ไข',
    fields: {
      id: 'รหัส',
      type: 'ประเภท',
      trigger: 'ตัวกระตุ้น',
      phase: 'ขั้นตอน',
      partner: 'พาร์ทเนอร์',
      partnerId: 'รหัสพาร์ทเนอร์',
      partnerIdOptional: 'รหัสพาร์ทเนอร์ (ไม่บังคับ)',
      checked: 'ตรวจสอบแล้ว',
      exceptions: 'ข้อยกเว้น',
      requestedAt: 'ร้องขอเมื่อ',
      requestedBy: 'ร้องขอโดย',
      processingStartedAt: 'เริ่มประมวลผลเมื่อ',
      lastHeartbeatAt: 'สัญญาณล่าสุด',
      completedAt: 'เสร็จเมื่อ',
      openExceptions: 'ข้อยกเว้นที่เปิดอยู่',
      resolvedExceptions: 'ข้อยกเว้นที่แก้แล้ว',
      failureCode: 'รหัสความล้มเหลว',
      failureAttempts: 'จำนวนครั้งที่ล้มเหลว',
      requestId: 'รหัสคำขอ',
      status: 'สถานะ',
      severity: 'ระดับความรุนแรง',
      entity: 'เอนทิตี',
      entityType: 'ประเภทเอนทิตี',
      entityId: 'รหัสเอนทิตี',
      lastDetected: 'ตรวจพบล่าสุด',
      firstDetected: 'ตรวจพบครั้งแรก',
      occurrences: 'จำนวนครั้ง',
      firstRunId: 'รหัสรอบแรก',
      lastRunId: 'รหัสรอบล่าสุด',
      from: 'จาก',
      to: 'ถึง',
      reason: 'เหตุผล',
      sourceTotal: 'ยอดจากแหล่งข้อมูล',
      internalTotal: 'ยอดภายใน',
      difference: 'ส่วนต่าง',
      currencyMismatch: 'ยอดเงิน / สกุลเงินไม่ตรงกัน',
      duplicateIds: 'รหัสซ้ำ',
      missingReceipts: 'ใบรับที่หายไป',
      staleReservations: 'ยอดจองค้าง',
      evidence: 'หลักฐาน',
      evidenceReference: 'หลักฐานอ้างอิง',
      method: 'วิธีแก้ไข',
      resolvedBy: 'แก้ไขโดย',
      resolvedAt: 'แก้ไขเมื่อ',
      acknowledgedBy: 'รับทราบโดย',
      acknowledgedAt: 'รับทราบเมื่อ',
      observationCount: 'จำนวนครั้งที่ตรวจยืนยัน',
      evidenceFingerprint: 'ลายนิ้วมือหลักฐาน',
      lastObservedAt: 'ตรวจสอบล่าสุดเมื่อ',
    },
    sections: {
      runSummary: 'สรุปรอบตรวจสอบ',
      timeline: 'ไทม์ไลน์',
      exceptionSummary: 'สรุปข้อยกเว้น',
      mismatchEvidence: 'หลักฐานส่วนต่างที่แก้ไขไม่ได้',
      relatedRecords: 'รายการที่เกี่ยวข้อง',
      resolution: 'การแก้ไข',
      acknowledgement: 'การรับทราบ',
    },
    errors: {
      loadRuns: 'ไม่สามารถโหลดรอบการกระทบยอดได้',
      loadRun: 'ไม่สามารถโหลดรอบการกระทบยอดนี้ได้',
      createRun: 'ไม่สามารถเข้าคิวรอบการกระทบยอดได้',
      loadExceptions: 'ไม่สามารถโหลดข้อยกเว้นการกระทบยอดได้',
      loadException: 'ไม่สามารถโหลดข้อยกเว้นนี้ได้',
      resolve: 'ไม่สามารถแก้ไขข้อยกเว้นนี้ได้',
      acknowledge: 'ไม่สามารถรับทราบข้อยกเว้นนี้ได้',
      stillMismatched: 'การกระทบยอดยังคงมียอดไม่ตรงกัน โปรดตรวจสอบหลักฐานแล้วลองอีกครั้ง',
      combinedMaximum: 'หลักฐานและเหตุผลรวมกันต้องไม่เกิน 2,000 ตัวอักษร',
    },
  },
  approvals: {
    title: 'การอนุมัติ',
    subtitle: 'ตรวจสอบคำขอเปลี่ยนแปลงที่อยู่ภายใต้การกำกับ บริบทการตัดสินใจ และประวัติการอนุมัติ',
    table: 'คำขออนุมัติ',
    compact: 'คำขออนุมัติแบบย่อ',
    empty: 'ไม่มีคำขออนุมัติที่ตรงกับตัวกรองเหล่านี้',
    selfApprovalBlocked:
      'คุณเป็นผู้ร้องขอการเปลี่ยนแปลงนี้ ผู้ร้องขอจึงไม่สามารถอนุมัติคำขอของตนเองได้ โปรดให้ผู้ตรวจสอบรายอื่นเป็นผู้ตัดสินใจ',
    pagination: { previous: 'ก่อนหน้า', next: 'ถัดไป' },
    fields: {
      id: 'รหัส',
      partnerId: 'รหัสพาร์ทเนอร์',
      actionType: 'การกระทำ',
      entityType: 'ประเภททรัพยากร',
      entityId: 'รหัสทรัพยากร',
      reason: 'เหตุผล',
      evidenceReference: 'หลักฐานอ้างอิง',
      status: 'สถานะ',
      requestedBy: 'ร้องขอโดย',
      requestedAt: 'ร้องขอเมื่อ',
      expiresAt: 'หมดอายุเมื่อ',
      decidedBy: 'ตัดสินใจโดย',
      decidedAt: 'ตัดสินใจเมื่อ',
      decisionReason: 'เหตุผลการตัดสินใจ',
      executedAt: 'ดำเนินการเมื่อ',
      executionReference: 'การอ้างอิงการดำเนินการ',
      requestId: 'รหัสคำขอ',
    },
    actions: {
      approve: 'อนุมัติ',
      reject: 'ปฏิเสธ',
      execute: 'ดำเนินการ',
      noActionAvailable: 'ไม่มีการดำเนินการที่ทำได้ · สถานะ: {{status}}',
    },
    decision: {
      approveTitle: 'อนุมัติคำขอ',
      rejectTitle: 'ปฏิเสธคำขอ',
      reason: 'เหตุผลการตัดสินใจ',
      submit: 'ส่งการตัดสินใจ',
      decided: 'บันทึกการตัดสินใจแล้ว',
    },
    execution: {
      title: 'ดำเนินการอนุมัติ',
      impact: 'การดำเนินการอนุมัตินี้จะทำการเคลื่อนย้ายเงินตามที่อนุมัติและไม่สามารถย้อนกลับได้',
      confirmCheckbox: 'ฉันยืนยันว่าต้องการดำเนินการเปลี่ยนแปลงที่อนุมัติแล้วนี้',
      confirm: 'ยืนยันดำเนินการ',
      executing: 'กำลังดำเนินการเปลี่ยนแปลงที่อนุมัติแล้ว…',
      stale: 'ตัวอย่างการอนุมัตินี้ล้าสมัยแล้ว โปรดรีเฟรชการอนุมัติล่าสุดก่อนดำเนินการอีกครั้ง',
      success: 'ดำเนินการเปลี่ยนแปลงที่อนุมัติแล้วเรียบร้อย',
      viewTarget: 'ดูทรัพยากรเป้าหมาย',
    },
    errors: {
      loadList: 'ไม่สามารถโหลดคำขออนุมัติได้',
      loadDetail: 'ไม่สามารถโหลดคำขออนุมัตินี้ได้',
      decision: 'ไม่สามารถบันทึกการตัดสินใจได้',
      execution: 'ไม่สามารถดำเนินการเปลี่ยนแปลงที่อนุมัติแล้วได้',
    },
  },
  audit: {
    title: 'การตรวจสอบ',
    subtitle: 'ติดตามการกระทำที่มีสิทธิพิเศษ ผู้กระทำ ทรัพยากรที่ได้รับผลกระทบ และหลักฐานคำขอ',
    table: 'บันทึกการตรวจสอบ',
    compact: 'บันทึกการตรวจสอบแบบย่อ',
    empty: 'ไม่มีรายการบันทึกการตรวจสอบตรงกับตัวกรอง',
    allPartners: 'พาร์ทเนอร์ทั้งหมด',
    noChangesRecorded: 'ไม่มีการเปลี่ยนแปลงก่อน/หลังที่ถูกบันทึกไว้สำหรับเหตุการณ์นี้',
    noAdditionalFields: 'ไม่มีข้อมูลเพิ่มเติมที่ถูกบันทึกไว้สำหรับเหตุการณ์นี้',
    pagination: { previous: 'ก่อนหน้า', next: 'ถัดไป' },
    fields: {
      id: 'รหัส',
      action: 'การกระทำ',
      entity: 'เอนทิตี',
      entityType: 'ประเภทเอนทิตี',
      entityId: 'รหัสเอนทิตี',
      actor: 'ผู้กระทำ',
      principalActorId: 'รหัสผู้กระทำ',
      principalRole: 'บทบาท',
      serviceActorId: 'รหัสผู้กระทำระบบ',
      partner: 'พาร์ทเนอร์',
      partnerId: 'รหัสพาร์ทเนอร์',
      agentId: 'รหัสเอเจนต์',
      requestId: 'รหัสคำขอ',
      correlationId: 'รหัสความสัมพันธ์',
      sourceIp: 'ไอพีต้นทาง',
      occurredAt: 'เกิดขึ้นเมื่อ',
      reason: 'เหตุผล',
      from: 'จาก',
      to: 'ถึง',
      before: 'ก่อน',
      after: 'หลัง',
    },
    sections: {
      beforeAfter: 'ก่อน / หลัง',
      metadata: 'ข้อมูลเมตาเพิ่มเติม',
    },
    errors: {
      loadList: 'ไม่สามารถโหลดรายการบันทึกการตรวจสอบได้',
      loadDetail: 'ไม่สามารถโหลดรายการบันทึกการตรวจสอบนี้ได้',
    },
  },
  securityEvents: {
    title: 'เหตุการณ์ความปลอดภัย',
    subtitle: 'ตรวจสอบสัญญาณการยืนยันตัวตน การอนุญาต และเหตุการณ์ความปลอดภัยที่น่าสงสัย',
    table: 'เหตุการณ์ความปลอดภัย',
    compact: 'เหตุการณ์ความปลอดภัยแบบย่อ',
    empty: 'ไม่มีเหตุการณ์ความปลอดภัยตรงกับตัวกรอง',
    pagination: { previous: 'ก่อนหน้า', next: 'ถัดไป' },
    fields: {
      id: 'รหัส',
      category: 'หมวดหมู่',
      severity: 'ระดับความรุนแรง',
      eventCode: 'รหัสเหตุการณ์',
      actor: 'ผู้กระทำ',
      principalActorId: 'รหัสผู้กระทำ',
      principalRole: 'บทบาท',
      serviceActorId: 'รหัสผู้กระทำระบบ',
      partnerId: 'รหัสพาร์ทเนอร์',
      agentId: 'รหัสเอเจนต์',
      credentialActorId: 'รหัสผู้ถือข้อมูลรับรอง',
      requestId: 'รหัสคำขอ',
      sourceIp: 'ไอพีต้นทาง',
      occurredAt: 'เกิดขึ้นเมื่อ',
      from: 'จาก',
      to: 'ถึง',
    },
    sections: {
      details: 'รายละเอียดเพิ่มเติม',
    },
    errors: {
      loadList: 'ไม่สามารถโหลดเหตุการณ์ความปลอดภัยได้',
      loadDetail: 'ไม่สามารถโหลดเหตุการณ์ความปลอดภัยนี้ได้',
    },
  },
  profile: {
    title: 'โปรไฟล์',
    fields: {
      name: 'ชื่อ',
      username: 'ชื่อผู้ใช้',
      email: 'อีเมล',
      role: 'บทบาท',
      authMode: 'รูปแบบการยืนยันตัวตน',
      identityProviderMode: 'Cognito (ผู้ให้บริการข้อมูลประจำตัว)',
      partnerId: 'รหัสพาร์ทเนอร์',
      agentId: 'รหัสเอเจนต์',
      permissionProfileId: 'รหัสโปรไฟล์สิทธิ์',
      permissions: 'สิทธิ์ที่มีผล',
    },
    sessions: {
      title: 'เซสชันที่ใช้งานอยู่',
      mockNotice:
        'ยังไม่มี API สำหรับแสดงรายการเซสชันในสัญญาปัจจุบัน เซสชันเหล่านี้เป็นข้อมูลจำลองที่กำหนดแน่นอนเพื่อการสาธิตเท่านั้น',
      ended: 'สิ้นสุดแล้ว (จำลอง)',
      signOutOthersMock: 'ออกจากระบบเซสชันอื่น (จำลอง)',
      resetMock: 'รีเซ็ต (จำลอง)',
    },
    identityProvider: {
      managed:
        'การยืนยันตัวตนอยู่ภายใต้การจัดการของผู้ให้บริการข้อมูลประจำตัวของคุณ การดำเนินการด้านล่างนี้ดำเนินการที่นั่นและไม่พร้อมใช้งานในคอนโซลนี้',
      password: 'การเปลี่ยนรหัสผ่าน',
      mfa: 'การยืนยันตัวตนหลายปัจจัย',
      login: 'การเข้าสู่ระบบ',
      refresh: 'การรีเฟรชโทเคน',
      sessions: 'การเพิกถอนเซสชัน',
    },
    signOut: {
      title: 'ออกจากระบบ',
      action: 'ออกจากระบบ',
      description: 'การออกจากระบบจะส่งต่อไปยังผู้ให้บริการข้อมูลประจำตัวของคุณและสิ้นสุดเซสชันนี้',
      mockAction: 'ออกจากระบบ (จำลอง)',
      mockDescription:
        'DEV Mock Auth ไม่มีเซสชัน backend ให้เพิกถอน การดำเนินการนี้รีเซ็ตเฉพาะเซสชันในเครื่องของคุณ',
    },
  },
  partnerCredit: {
    title: 'เครดิตพาร์ทเนอร์',
    subtitle: 'กำหนดค่าการส่งเครดิตพาร์ทเนอร์แบบมีเวอร์ชันและผ่านการอนุมัติสำหรับแต่ละพาร์ทเนอร์',
    detailSubtitle: 'การกำหนดค่า Integration ของพาร์ทเนอร์ {{partnerId}}',
    configured: 'กำหนดค่าแล้ว',
    notConfigured: 'ยังไม่ได้กำหนดค่า',
    emptyPartners: 'ไม่มีพาร์ทเนอร์สำหรับกำหนดค่าเครดิตพาร์ทเนอร์',
    emptyVersions: 'ยังไม่มีเวอร์ชันการกำหนดค่าแบบแก้ไขไม่ได้ที่เผยแพร่แล้ว',
    partnerList: 'ตัวเลือกพาร์ทเนอร์สำหรับเครดิตพาร์ทเนอร์',
    pagination: {
      summary: 'หน้า {{page}} จาก {{pages}} · พาร์ทเนอร์ {{total}} ราย',
      previous: 'หน้าก่อนหน้า',
      next: 'หน้าถัดไป',
    },
    versionTable: 'เวอร์ชันการกำหนดค่าเครดิตพาร์ทเนอร์',
    versionTitle: 'เวอร์ชันเครดิตพาร์ทเนอร์',
    versionNotFound: 'ไม่พบเวอร์ชันเครดิตพาร์ทเนอร์นี้',
    secretOmitted: 'ข้อมูลลับของ Credential เขียนได้อย่างเดียวและจะไม่ถูกส่งกลับหรือแสดงผล',
    actions: {
      openPartner: 'เปิดเครดิตพาร์ทเนอร์ของ {{partner}}',
      createVersion: 'สร้างเวอร์ชัน',
      preview: 'ดูตัวอย่างการกำหนดค่า',
      requestApproval: 'ขออนุมัติ',
      certify: 'รับรองเวอร์ชัน',
      runCertification: 'ดำเนินการรับรอง',
      suspend: 'ระงับการส่งเครดิต',
      activate: 'เปิดใช้การส่งเครดิต',
    },
    sections: {
      current: 'การกำหนดค่าปัจจุบัน',
      versions: 'เวอร์ชันที่แก้ไขไม่ได้',
      publicConfiguration: 'การกำหนดค่าสาธารณะ',
    },
    fields: {
      id: 'รหัสเวอร์ชัน',
      name: 'ชื่อ Integration',
      status: 'สถานะการส่งเครดิต',
      version: 'เวอร์ชัน',
      authType: 'ประเภทการยืนยันตัวตน',
      keyReference: 'ข้อมูลอ้างอิงคีย์',
      creditEndpoint: 'Endpoint เครดิต',
      statusEndpoint: 'Endpoint สถานะ',
      healthEndpoint: 'Endpoint สุขภาพ',
      transactionResultEndpoint: 'Endpoint ผลลัพธ์ธุรกรรม',
      transactionResultEndpointHelp:
        'Callback HTTPS แบบไม่บังคับสำหรับผลลัพธ์สุดท้ายของการส่งธุรกรรม',
      oauthTokenEndpoint: 'Endpoint โทเค็น OAuth',
      oauthClientId: 'รหัส Client OAuth',
      oauthScopes: 'Scope OAuth',
      oauthAudience: 'Audience OAuth',
      timeout: 'หมดเวลา (มิลลิวินาที)',
      maximumAttempts: 'จำนวนครั้งสูงสุด',
      initialDelay: 'เวลารอเริ่มต้น (วินาที)',
      maximumDelay: 'เวลารอสูงสุด (วินาที)',
      multiplier: 'ตัวคูณการลองซ้ำ',
      jitter: 'Jitter (เปอร์เซ็นต์)',
      secret: 'ข้อมูลลับแบบเขียนอย่างเดียว',
      reason: 'เหตุผล',
      certifiedAt: 'รับรองเมื่อ',
      publishedAt: 'เผยแพร่เมื่อ',
      certification: 'การรับรอง',
      approvalRequestId: 'รหัสคำขออนุมัติ',
      previewHash: 'แฮชตัวอย่าง',
    },
    wizard: {
      title: 'สร้างเวอร์ชันเครดิตพาร์ทเนอร์',
      description:
        'ดูตัวอย่างการกำหนดค่าสาธารณะที่แน่นอน แล้วขออนุมัติแบบ maker-checker โดยจะไม่มีการส่งเครดิตออก',
      secretNotice:
        'ข้อมูลลับเขียนได้อย่างเดียว ระบบส่งเพื่อดูตัวอย่างและขออนุมัติ แต่จะไม่แสดงอีกครั้ง',
      previewTitle: 'ตัวอย่างที่ปรับรูปแบบแล้ว',
      targetPartner: 'รหัสไอดีพาร์ทเนอร์ที่เลือก',
      currentImpact: 'การส่งเครดิตปัจจุบัน',
      proposedImpact: 'ผลกระทบที่เสนอ',
      pendingImpact: 'อยู่ระหว่างรออนุมัติและการรับรอง โดยการส่งเครดิตปัจจุบันยังไม่เปลี่ยนแปลง',
      confirmPublish: 'ฉันยืนยันเวอร์ชันเครดิตพาร์ทเนอร์นี้และผลกระทบต่อการส่งเครดิต',
      certificationRequired: 'ต้องรับรองก่อนเปิดใช้งาน',
      pendingApproval: 'รออนุมัติ: {{id}}',
    },
    certification: {
      title: 'รับรองเวอร์ชันเครดิตพาร์ทเนอร์',
      description: 'ใช้คำขออนุมัติการเผยแพร่ที่รอดำเนินการเพื่อรับรองเวอร์ชันที่เสนอ',
      nonFinancial:
        'การรับรองจะเรียกเฉพาะสุขภาพและสถานะ Transfer ที่ไม่รู้ผลแบบยืนยันตัวตน และจะไม่ส่งเครดิต',
      passed: 'การรับรองผ่าน · Health HTTP {{health}} · Status HTTP {{status}}',
    },
    status: {
      impact:
        'การส่งเครดิตจะเปลี่ยนจาก {{current}} เป็น {{proposed}} การเปิดใช้ต้องมีเวอร์ชันปัจจุบันที่รับรองแล้ว',
      confirm: 'ฉันยืนยันการเปลี่ยนสถานะการส่งเครดิตและผลกระทบต่อการดำเนินงาน',
    },
    health: {
      title: 'สุขภาพ Integration',
      mockNotice:
        'ข้อมูลจำลอง DEV สำหรับสุขภาพการดำเนินงานที่ไม่ใช่การเงิน โดยไม่ได้เรียก Endpoint ของพาร์ทเนอร์',
      unavailable:
        'API ปัจจุบันยังไม่เปิดเผยสุขภาพเครดิตพาร์ทเนอร์แบบไม่ใช่การเงิน จึงไม่มีการส่งคำขอ API',
      status: 'สถานะสุขภาพ',
      successRate: 'อัตราสำเร็จ',
      latency: 'เวลาแฝง',
      retries: 'จำนวนครั้งที่ลองซ้ำ',
      unknownResults: 'ผลลัพธ์ที่ไม่ทราบ',
      oldestReservation: 'อายุยอดจองที่เก่าที่สุด',
      exceptions: 'ข้อยกเว้นการกระทบยอด',
    },
    errors: {
      load: 'ไม่สามารถโหลดสรุปพาร์ทเนอร์สำหรับเครดิตพาร์ทเนอร์ได้',
      loadDetail: 'ไม่สามารถโหลดการกำหนดค่าเครดิตพาร์ทเนอร์นี้ได้',
      loadVersion: 'ไม่สามารถโหลดเวอร์ชันเครดิตพาร์ทเนอร์นี้ได้',
      preview: 'ไม่สามารถดูตัวอย่างการกำหนดค่าเครดิตพาร์ทเนอร์นี้ได้',
      publish: 'ไม่สามารถขออนุมัติเวอร์ชันเครดิตพาร์ทเนอร์นี้ได้',
      certify: 'ไม่สามารถรับรองเวอร์ชันเครดิตพาร์ทเนอร์นี้ได้',
      status: 'ไม่สามารถเปลี่ยนสถานะการส่งเครดิตพาร์ทเนอร์ได้',
    },
  },
  reports: {
    title: 'รายงาน',
    subtitle: 'รายงานการดำเนินงานและการเงินที่ผูกกับ Snapshot',
    summaryTitle: 'สรุปจากรายงาน',
    unavailableMetric:
      'ตัวชี้วัดที่รายงานไม่ได้ส่งกลับจะแสดงว่าไม่พร้อมใช้งาน โดยไม่มีการประมาณค่า',
    activityReport: 'รายงานกิจกรรมการดำเนินงาน',
    type: 'ประเภทรายงาน',
    filters: 'ตัวกรองรายงาน',
    from: 'ตั้งแต่ (รวม)',
    to: 'ถึง (ไม่รวม)',
    timezone: 'เขตเวลา',
    timeBasis: 'ฐานเวลา',
    currency: 'สกุลเงิน',
    status: 'สถานะ',
    partnerId: 'รหัสพาร์ทเนอร์',
    agentId: 'รหัสเอเจนต์',
    memberId: 'รหัสสมาชิก',
    uplineMemberId: 'รหัสสมาชิกอัปไลน์',
    gameTypeId: 'รหัสประเภทเกม',
    gameId: 'รหัสเกม',
    sort: 'การเรียงฝั่งเซิร์ฟเวอร์',
    timeBases: {
      PLAY_AT: 'เวลาเล่น',
      RECEIVED_AT: 'เวลารับข้อมูล',
      EFFECTIVE_AT: 'เวลามีผล',
      REGISTERED_AT: 'เวลาลงทะเบียน',
      CREATED_AT: 'เวลาสร้าง',
      OCCURRED_AT: 'เวลาเกิดเหตุ',
    },
    sortOptions: {
      occurredAt: 'เวลาเกิดเหตุ',
      amount: 'จำนวนเงิน',
      code: 'รหัส',
      name: 'ชื่อ',
    },
    empty: 'ไม่พบแถวรายงานที่ตรงกับตัวกรอง',
    stale: 'นี่คือ Snapshot ล่าสุดที่เสร็จสมบูรณ์และอาจล่าช้า',
    snapshot: 'Snapshot {{id}} · ข้อมูล ณ {{date}}',
    requestId: 'รหัสคำขอ: {{id}}',
    columns: {
      occurredAt: 'เวลาเกิดเหตุ',
      identity: 'ข้อมูลอ้างอิง',
      status: 'สถานะ',
      currency: 'สกุลเงิน',
      metrics: 'ตัวชี้วัด',
    },
    pagination: {
      previous: 'ก่อนหน้า',
      next: 'ถัดไป',
      server: 'ผลลัพธ์เรียงตาม Cursor จากเซิร์ฟเวอร์',
    },
    exportQueued: 'เข้าคิวส่งออกรายงานแล้ว: {{id}}',
    exportError: 'ไม่สามารถเข้าคิวส่งออกรายงานได้',
    kinds: {
      transactions: 'ธุรกรรม',
      agentCommissions: 'ค่าคอมมิชชันเอเจนต์',
      affiliateCommissions: 'ค่าคอมมิชชันแอฟฟิลิเอต',
      games: 'เกม',
      registrations: 'การลงทะเบียน',
      partnerReconciliation: 'กระทบยอดพาร์ทเนอร์',
      commissionRuleUsage: 'การใช้กฎค่าคอมมิชชัน',
      auditActivity: 'กิจกรรมตรวจสอบ',
      wallets: 'กระเป๋าเงิน',
      walletLedger: 'บัญชีกระเป๋าเงิน',
      withdrawals: 'การถอนเงิน',
      partnerCreditReconciliation: 'กระทบยอดเครดิตพาร์ทเนอร์',
      userAffiliateByGame: 'ผู้ใช้และแอฟฟิลิเอตแยกตามเกม',
    },
    meta: {
      title: 'ข้อมูล Snapshot',
      snapshotId: 'รหัส Snapshot',
      timeBasis: 'ฐานเวลา',
      timezone: 'เขตเวลา',
      reportingAsOf: 'ข้อมูล ณ',
      refreshedAt: 'รีเฟรชเมื่อ',
      stale: 'Snapshot ล่าช้า',
      normalizedFilters: 'ตัวกรองที่ปรับรูปแบบแล้ว',
    },
    totals: {
      title: 'ยอดรวมแยกตามสกุลเงิน',
      playAmount: 'ยอดเล่น',
      agentCommissionGross: 'ค่าคอมมิชชันเอเจนต์ขั้นต้น',
      affiliateCommissionGross: 'ค่าคอมมิชชันแอฟฟิลิเอตขั้นต้น',
      commissionReversals: 'ค่าคอมมิชชันที่ย้อนกลับ',
      commissionAdjustments: 'การปรับค่าคอมมิชชัน',
      netCommission: 'ค่าคอมมิชชันสุทธิ',
      walletAvailable: 'ยอดกระเป๋าที่ใช้ได้',
      walletReserved: 'ยอดกระเป๋าที่จอง',
      withdrawalRequested: 'ยอดถอนที่ร้องขอ',
      withdrawalReserved: 'ยอดถอนที่จอง',
      withdrawalCompleted: 'ยอดถอนที่เสร็จสิ้น',
      withdrawalReleased: 'ยอดถอนที่คืน',
      withdrawalUnknown: 'ยอดถอนที่ไม่ทราบผล',
    },
  },
  reportSummaries: {
    unavailable: 'ไม่มีข้อมูลจากรายละเอียดที่โหลดอยู่',
    viewReport: 'ดู{{report}}',
    metrics: {
      partnerRequests: 'คำขอทั้งหมด',
      partnerActivity: 'กิจกรรมทั้งหมด',
      transactions: 'ธุรกรรมทั้งหมด',
      actualPlay: 'ยอดเล่นจริงรวม',
      commission: 'ค่าคอมมิชชันรวม',
      affiliateByGame: 'สรุปแอฟฟิลิเอตแยกตามเกม',
      wallet: 'สรุปกระเป๋าเงิน',
      withdrawals: 'สรุปการถอนเงิน',
      generatedCommission: 'ค่าคอมมิชชันที่สร้าง',
      walletReconciliation: 'การกระทบยอดกระเป๋าเงิน',
    },
  },
  reportExports: {
    title: 'ส่งออกรายงาน',
    subtitle: 'ไฟล์ CSV ส่วนตัวที่ผูกกับ Snapshot',
    empty: 'ไม่พบรายการส่งออกรายงานที่ตรงกับตัวกรอง',
    detail: 'รายละเอียดการส่งออกรายงาน',
    download: 'ดาวน์โหลด CSV',
    downloadError: 'ไม่สามารถดาวน์โหลดรายงานนี้ได้',
    expired: 'รายงานนี้หมดอายุและดาวน์โหลดไม่ได้แล้ว',
    notReady: 'ดาวน์โหลดได้เมื่อสร้างรายงานเสร็จสมบูรณ์',
    failed: 'การส่งออกรายงานล้มเหลวและดาวน์โหลดไม่ได้ โปรดตรวจสอบรหัสความล้มเหลวที่ปลอดภัย',
    failureCode: 'รหัสความล้มเหลว',
    createdAt: 'เวลาที่ขอ',
    requestedBy: 'ผู้ร้องขอ',
    partnerScope: 'ขอบเขตพาร์ทเนอร์',
    agentScope: 'ขอบเขตเอเจนต์',
    timezone: 'เขตเวลา',
    currency: 'สกุลเงิน',
    format: 'รูปแบบ',
    metadataTitle: 'ข้อมูลการส่งออก',
    filtersTitle: 'ตัวกรองส่งออกที่ปรับรูปแบบแล้ว',
    generatedAt: 'เวลาที่สร้างไฟล์',
    completedAt: 'เวลาที่เสร็จสิ้น',
    updatedAt: 'เวลาที่อัปเดต',
    expiresAt: 'หมดอายุ',
    snapshotId: 'รหัส Snapshot',
    recordCount: 'จำนวนรายการ',
    contentLength: 'ขนาดข้อมูล (ไบต์)',
    filenameNotice: 'ระบบจะขอไฟล์ส่วนตัวเมื่อคุณเลือกดาวน์โหลดเท่านั้น',
    pagination: { previous: 'ก่อนหน้า', next: 'ถัดไป' },
    filters: {
      requestedBy: 'รหัสผู้ร้องขอ',
      partnerId: 'รหัสพาร์ทเนอร์',
      agentId: 'รหัสเอเจนต์',
      from: 'ขอตั้งแต่',
      to: 'ขอถึง',
    },
  },
  capability: {
    backendUnavailable: 'ความสามารถฝั่ง backend ยังไม่พร้อมใช้งาน จึงไม่มีการส่งคำขอ API',
  },
  sensitiveAction: {
    reason: 'เหตุผล',
    reasonRequired: 'กรุณาระบุเหตุผล',
    reasonMaximum: 'เหตุผลต้องไม่เกิน 2,000 ตัวอักษร',
    evidence: 'หลักฐานอ้างอิง',
    evidenceOptional: 'หลักฐานอ้างอิง (ไม่บังคับ)',
    evidenceRequired: 'กรุณาระบุหลักฐานอ้างอิง',
    confirmError: 'ไม่สามารถยืนยันการดำเนินการนี้ได้ โปรดลองอีกครั้ง',
  },
  actions: {
    apply: 'นำไปใช้',
    approve: 'อนุมัติ',
    cancel: 'ยกเลิก',
    clear: 'ล้าง',
    close: 'ปิด',
    confirm: 'ยืนยัน',
    create: 'สร้าง',
    delete: 'ลบ',
    edit: 'แก้ไข',
    export: 'ส่งออก',
    reject: 'ปฏิเสธ',
    retry: 'ลองอีกครั้ง',
    save: 'บันทึก',
    view: 'ดู',
  },
  filters: {
    dateFrom: 'วันที่เริ่มต้น',
    dateTo: 'วันที่สิ้นสุด',
    partner: 'พาร์ทเนอร์',
    agent: 'เอเจนต์',
    member: 'สมาชิก',
    status: 'สถานะ',
    outcome: 'ผลลัพธ์',
    code: 'รหัส',
    username: 'ชื่อผู้ใช้',
    partnerUserId: 'รหัสผู้ใช้พาร์ทเนอร์',
    entryType: 'ประเภทรายการ',
    search: 'ค้นหาตัวกรอง',
  },
  dataSource: {
    label: 'แหล่งข้อมูล',
    mock: 'ข้อมูลจำลอง',
    real: 'API จริง',
    unavailable: 'ไม่พร้อมใช้งาน',
  },
  shell: {
    closeNavigation: 'ปิดเมนูนำทาง',
    collapseNavigation: 'ย่อเมนูนำทาง',
    colorScheme: 'โหมดสี',
    darkMode: 'มืด',
    expandNavigation: 'ขยายเมนูนำทาง',
    language: 'ภาษา',
    lightMode: 'สว่าง',
    mainContent: 'เนื้อหาหลัก',
    openNavigation: 'เปิดเมนูนำทาง',
    primaryNavigation: 'เมนูนำทางหลัก',
  },
  languages: {
    en: 'English',
    th: 'ไทย',
  },
  scaffold: {
    capability: 'ความสามารถ',
    knownCapability: 'ความสามารถ API ที่รู้จัก',
    readOnly:
      'หน้าชั่วคราวนี้เป็นแบบอ่านอย่างเดียว การควบคุมที่มีสิทธิ์สูงจะเพิ่มเฉพาะพร้อมเวิร์กโฟลว์ที่อนุมัติแล้ว',
    scopes: {
      authProfile: 'ตรวจสอบตัวตน ขอบเขต และบริบทสิทธิ์ที่มีผลในปัจจุบัน',
      dashboard: 'ติดตามประสิทธิภาพแอฟฟิลิเอต สัญญาณทางการเงิน และคิวการดำเนินงาน',
      partners: 'ตรวจสอบองค์กรพาร์ทเนอร์ เจ้าของ วงจรสถานะ และขอบเขตเชิงพาณิชย์',
      agents: 'ตรวจสอบบัญชีเอเจนต์ การกำหนดพาร์ทเนอร์ สถานะ และขอบเขตการดำเนินงาน',
      adminUsers: 'จัดการตัวตนระบบหลังบ้าน บทบาท สิทธิ์ที่มีผล และสถานะการเข้าถึง',
      members: 'ติดตามโปรไฟล์สมาชิก ความสัมพันธ์การแนะนำ และการระบุแอฟฟิลิเอต',
      games: 'ตรวจสอบแค็ตตาล็อกเกม การจับคู่ผู้ให้บริการ และการเปิดใช้สำหรับแอฟฟิลิเอต',
      commissionRules: 'ตรวจสอบนิยามกฎค่าคอมมิชชัน การใช้งาน เวอร์ชัน และสถานะอนุมัติ',
      transactions: 'ตรวจสอบกิจกรรมธุรกรรม ผลลัพธ์ จำนวนเงิน และการระบุแอฟฟิลิเอต',
      transactionReversal: 'ตรวจสอบสิทธิ์การย้อนรายการ การตัดสินใจ และสถานะที่เกิดขึ้น',
      transactionFailures: 'ตรวจสอบธุรกรรมที่ล้มเหลว เหตุผล และความพร้อมในการแก้ไข',
      apiOperations: 'ตรวจสอบคำขอ API เพื่อการดำเนินงาน ผลลัพธ์ และหลักฐานคำขอ',
      commissionLedger: 'ตรวจสอบรายการค่าคอมมิชชันที่คำนวณ การปรับปรุง และข้อมูลอ้างอิงการชำระ',
      commissionAdjustments: 'ตรวจสอบคำขอปรับค่าคอมมิชชัน หลักฐาน และผลกระทบต่อบัญชี',
      audit: 'ติดตามการกระทำที่มีสิทธิ์สูง ผู้ดำเนินการ ทรัพยากร และหลักฐานคำขอ',
      securityEvents: 'ตรวจสอบสัญญาณการยืนยันตัวตน การอนุญาต และเหตุการณ์ความปลอดภัยที่น่าสงสัย',
      wallets: 'ตรวจสอบยอดคงเหลือ สถานะกระเป๋าเงิน และประวัติการเคลื่อนไหวของยอดเงิน',
      withdrawals: 'ติดตามคำขอถอนเงิน การประมวลผล และประวัติการแก้ไข',
      partnerCredit:
        'กำหนดค่าการส่งเครดิตพาร์ทเนอร์แบบมีเวอร์ชันและผ่านการอนุมัติโดยไม่เปิดเผยข้อมูลลับ',
      partnerCreditHealth:
        'ติดตามสุขภาพการดำเนินงานเครดิตพาร์ทเนอร์แบบไม่ใช่การเงินเมื่อ backend รองรับ',
      approvals: 'ตรวจสอบคำขอเปลี่ยนแปลงที่อยู่ภายใต้การกำกับ บริบท และประวัติการอนุมัติ',
      reconciliation: 'เปรียบเทียบข้อมูลแพลตฟอร์มกับยอดผู้ให้บริการและระบุข้อยกเว้นการกระทบยอด',
      reportExports: 'ติดตามคำขอส่งออกรายงาน สถานะการสร้าง และความพร้อมดาวน์โหลด',
      reports: 'ตรวจสอบรายงานการดำเนินงานและการเงินของแพลตฟอร์มแอฟฟิลิเอต',
    },
  },
  accessDenied: 'ปฏิเสธการเข้าถึง',
  api: 'API ระบบหลังบ้าน',
  area: 'ระบบหลังบ้าน',
  brand: 'แพลตฟอร์มแอฟฟิลิเอต',
  build: 'บิลด์',
  description:
    'ฟีเจอร์ที่มีสิทธิ์สูงจะยังไม่พร้อมใช้งานจนกว่าจะอนุมัติผู้ให้บริการข้อมูลประจำตัวและนโยบายการอนุญาตสำหรับระบบจริง',
  environment: 'สภาพแวดล้อม',
  foundation: 'สภาพแวดล้อมพื้นฐาน',
  metadata: 'ข้อมูลการปรับใช้',
  title: 'ยังไม่ได้กำหนดค่าการเข้าถึงระบบหลังบ้าน',
  version: 'เวอร์ชัน',
} as const;
